export const TRANSLATIONS = {
    EN: {
        GENERAL_WORKFLOW: {
            COMPLETE_JOB: {
                CLIENT: {
                    TITLE: 'Job in progress',
                },
                NOTARY: {
                    TITLE: 'Job in progress',
                },
                SUPPORT: {
                    TITLE: 'Job in progress',
                },
                BOOKKEEPER: {
                    TITLE: 'Job in progress',
                },
            },
            REVIEW_JOB: {
                CLIENT: {
                    TITLE: 'Confirm job completion',
                },
                NOTARY: {
                    TITLE: 'Review job',
                },
                SUPPORT: {
                    TITLE: 'Review job',
                },
                BOOKKEEPER: {
                    TITLE: 'Confirm job completion',
                },
            },
            WAIT_FOR_PAYMENT_RETAINER: {
                CLIENT: {
                    TITLE: 'Retainer payment intake interview',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Retainer payment intake interview',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Retainer payment intake interview',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Retainer payment intake interview',
                    DESCRIPTION: '',
                },
            },
            REVIEW_APPLICATION: {
                CLIENT: {
                    TITLE: 'Review application',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Review application',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Review application',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Review application',
                    DESCRIPTION: '',
                },
            },
            PLAN_INTERVIEW: {
                CLIENT: {
                    TITLE: 'Schedule an appointment in the agenda',
                },
                NOTARY: {
                    TITLE: 'Waiting for customer to make an appointment',
                },
                SUPPORT: {
                    TITLE: 'Waiting for customer to make an appointment',
                },
                BOOKKEEPER: {
                    TITLE: 'Schedule an appointment in the agenda',
                },
            },
            INTERVIEW_OVERVIEW: {
                CLIENT: {
                    TITLE: 'Appointment is scheduled',
                },
                NOTARY: {
                    TITLE: 'Appointment is scheduled',
                },
                SUPPORT: {
                    TITLE: 'Appointment is scheduled',
                },
                BOOKKEEPER: {
                    TITLE: 'Appointment is scheduled',
                },
            },
            PROCESS_JOB: {
                CLIENT: {
                    TITLE: 'Application in progress',
                },
                NOTARY: {
                    TITLE: 'Application in progress',
                },
                SUPPORT: {
                    TITLE: 'Application in progress',
                },
                BOOKKEEPER: {
                    TITLE: 'Application in progress',
                },
            },
            WAIT_FOR_REVIEW_JOB: {
                CLIENT: {
                    TITLE: 'Wait for approval milestones',
                },
                NOTARY: {
                    TITLE: 'Wait for approval milestones',
                },
                SUPPORT: {
                    TITLE: 'Wait for approval milestones',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for approval milestones',
                },
            },
            RESUBMIT_RESULT: {
                CLIENT: {
                    TITLE: 'Upload new milestone result',
                },
                NOTARY: {
                    TITLE: 'Upload new milestone result',
                },
                SUPPORT: {
                    TITLE: 'Upload new milestone result',
                },
                BOOKKEEPER: {
                    TITLE: 'Upload new milestone result',
                },
            },
            ASSIGN_SERVICE_PROVIDER: {
                CLIENT: {
                    TITLE: 'The application has been rejected by the service provider',
                },
                NOTARY: {
                    TITLE: 'The application has been rejected by the service provider',
                },
                SUPPORT: {
                    TITLE: 'Review the rejection by the service provider',
                },
                BOOKKEEPER: {
                    TITLE: 'The application has been rejected by the service provider',
                },
            },
            INTAKE_INTERVIEW: {
                CLIENT: {
                    TITLE: 'Intake interview',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Intake interview',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Intake interview',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Intake interview',
                    DESCRIPTION: '',
                },
            },
            REVIEW_MILESTONE: {
                CLIENT: {
                    TITLE: 'Review milestone',
                },
                NOTARY: {
                    TITLE: 'Review milestone',
                },
                SUPPORT: {
                    TITLE: 'Review milestone',
                },
                BOOKKEEPER: {
                    TITLE: 'Review milestone',
                },
            },
            WAIT_FOR_PAYMENT_QUOTE: {
                CLIENT: {
                    TITLE: 'Payment quote',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Payment quote',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Payment quote',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Payment quote',
                    DESCRIPTION: '',
                },
            },
            VERIFY_ORGANIZATION: {
                CLIENT: {
                    TITLE: 'Verification for application',
                    DESCRIPTION:
                        'For the digital identification we need the following data per person. Please enter the details of all persons who need to be identified below.',
                },
                NOTARY: {
                    TITLE: 'Verification for application',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Verification for application',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'KYC onboarding',
                    DESCRIPTION: '',
                },
            },
            UPLOAD_RESULT: {
                CLIENT: {
                    TITLE: 'Job completion',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Job completion',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Job completion',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Job completion',
                    DESCRIPTION: '',
                },
            },
            EDIT_DETAILS: {
                CLIENT: {
                    TITLE: 'Your application is being processed',
                    DESCRIPTION:
                        '{tenant} is preparing the documents. We will keep you informed about the status of the liquidation. If you need to take action, you will be notified by email. So please keep an eye on your mailbox.',
                },
                SUPPORT: {
                    TITLE: 'Preparing the documents',
                    DESCRIPTION:
                        'An employee of {tenant} is preparing the documents. We will keep you informed about the status of the liquidation. If you need to take an action, you will be notified by email. So please keep an eye on your mailbox.',
                },
            },
            SIGN_BY_HAND: {
                CLIENT: {
                    TITLE: 'Send documents to {tenant}',
                    DESCRIPTION: 'Download, print, sign and send the delivered documents by post to {tenant}.',
                },
                SUPPORT: {
                    TITLE: 'Wait for signed documents',
                    DESCRIPTION: 'Print, sign and send the delivered documents by post to {tenant}.',
                },
                NOTARY: {
                    TITLE: 'Wait for signed documents',
                    DESCRIPTION: 'Print, sign and send the delivered documents by post to {tenant}.',
                },
                BOOKKEEPER: {
                    TITLE: 'Send documents to {tenant}',
                    DESCRIPTION: 'Download, print, sign and send the delivered documents by post to {tenant}.',
                },
            },
            APPROVE_DOCUMENT: {
                CLIENT: {
                    TITLE: 'Wait for confirmation by {tenant}',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Send documents to Chamber of Commerce',
                },
                SUPPORT: {
                    TITLE: 'Send documents to Chamber of Commerce',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for confirmation by {tenant}',
                    DESCRIPTION: '',
                },
            },
            DEREGISTER_COMPANY: {
                CLIENT: {
                    TITLE: 'Deregister company',
                    DESCRIPTION: 'The company {company} is being deregistered.',
                },
                NOTARY: {
                    TITLE: 'Check the Chamber of Commerce for an update',
                    DESCRIPTION: 'Check the Chamber of Commerce for an update and give notice to the client when {company} is deregistered.',
                },
                SUPPORT: {
                    TITLE: 'Check the Chamber of Commerce for an update',
                    DESCRIPTION: 'Check the Chamber of Commerce for an update and give notice to the client when {company} is deregistered.',
                },
                BOOKKEEPER: {
                    TITLE: 'Deregister company',
                    DESCRIPTION: 'The company {company} is being deregistered.',
                },
            },
            SUBMIT_DETAILS: {
                CLIENT: {
                    TITLE: 'Client fills out data',
                },
                NOTARY: {
                    TITLE: 'Client fills out data',
                },
                SUPPORT: {
                    TITLE: 'Client fills out data',
                },
                BOOKKEEPER: {
                    TITLE: 'Client fills out data',
                },
            },
            WAIT_FOR_PAYMENT: {
                CLIENT: {
                    TITLE: 'Waiting for payment',
                },
                NOTARY: {
                    TITLE: 'Waiting for payment',
                },
                SUPPORT: {
                    TITLE: 'Waiting for payment',
                },
                BOOKKEEPER: {
                    TITLE: 'Waiting for payment',
                },
            },
            WAIT_FOR_PAYMENT_INCORPORATION: {
                CLIENT: {
                    TITLE: 'Waiting for payment',
                },
                NOTARY: {
                    TITLE: 'Waiting for payment',
                },
                SUPPORT: {
                    TITLE: 'Waiting for payment',
                },
                BOOKKEEPER: {
                    TITLE: 'Waiting for payment',
                },
            },
            SUBMIT_ADDITIONAL_DETAILS: {
                CLIENT: {
                    TITLE: 'Submit additional details',
                },
                NOTARY: {
                    TITLE: 'Submit additional details',
                },
                SUPPORT: {
                    TITLE: 'Submit additional details',
                },
                BOOKKEEPER: {
                    TITLE: 'Submit additional details',
                },
            },
            WAIT_FOR_IDENTIFICATION: {
                CLIENT: {
                    TITLE: 'Complete digital identification',
                    DESCRIPTION:
                        'Before the service provider can start the process, all participant(s) must identify themselves digitally. An invitation has been sent to every founder with a link to start the digital identification. If the mail has not arrived correctly, you can still change the email address. The invitation will be automatically resent.',
                },
                NOTARY: {
                    TITLE: 'Complete digital identification',
                    DESCRIPTION:
                        'Each person has received an invitation by email for the digital identification. You can easily change a founder’s email address or phone number as long as the identification has not been completed. The applicant of the procedure can also do this himself.',
                },
                SUPPORT: {
                    TITLE: 'Complete digital identification',
                    DESCRIPTION:
                        'Each person has received an invitation by email for the digital identification. You can easily change a founder’s email address or phone number as long as the identification has not been completed. The applicant of the procedure can also do this himself.',
                },
                BOOKKEEPER: {
                    TITLE: 'Complete digital identification',
                    DESCRIPTION:
                        'Each person has received an invitation by email for the digital identification. You can easily change a founder’s email address or phone number as long as the identification has not been completed. The applicant of the procedure can also do this himself.',
                },
            },
            UPLOAD_LIQUIDATION: {
                SUPPORT: {
                    VALIDATION_ALL: 'Please select at least one document of each type: Liquidation Resolution and Liquidation Kvk.',
                },
            },
            WAIT_FOR_PREPARE_SIGNING: {
                CLICK_TO_PREPARE: 'Prepare document',
                CLIENT: {
                    TITLE: 'Wait for prepare signing',
                    DESCRIPTION:
                        'The service provider will prepare the signing of the documents. You will receive a notification by e-mail as soon as these documents are ready in your dashboard.',
                },
                NOTARY: {
                    TITLE: 'Wait for prepare signing',
                    DESCRIPTION:
                        'Wait for signing the documents by the signers. Uploaded the wrong document? Easily adjust the document and upload the correct one.',
                },
                SUPPORT: {
                    TITLE: 'Wait for prepare signing',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for prepare signing',
                },
            },
            REVIEW_DOSSIER: {
                BOOKKEEPER: {
                    TITLE: 'Review UBO application',
                    DESCRIPTION:
                        'The notary has received the application, will check the application and will proceed with the procedure. You will receive a notification by e-mail as soon as the application is submitted to the UBO register.',
                },
                CLIENT: {
                    TITLE: 'Review UBO application',
                    DESCRIPTION:
                        'The notary has received the application, will check the application and will proceed with the procedure. You will receive a notification by e-mail as soon as the application is submitted to the UBO register.',
                },
                NOTARY: {
                    TITLE: 'Review UBO application',
                },
                SUPPORT: {
                    TITLE: 'Review UBO application',
                },
            },
            FINISH_REGISTRATION: {
                BOOKKEEPER: {
                    TITLE: 'Confirm UBO registration',
                    DESCRIPTION:
                        'The application for UBO registration has been submitted to the UBO register. You will receive a notification by e-mail as soon as the registration is confirmed.',
                },
                CLIENT: {
                    TITLE: 'Confirm UBO registration',
                    DESCRIPTION:
                        'The application for UBO registration has been submitted to the UBO register. You will receive a notification by e-mail as soon as the registration is confirmed.',
                },
                NOTARY: {
                    TITLE: 'Confirm UBO registration',
                },
                SUPPORT: {
                    TITLE: 'Confirm UBO registration',
                },
            },
            WAIT_FOR_SIGNING: {
                CLIENT: {
                    TITLE: 'Signing documents',
                    DESCRIPTION:
                        'A document has been drafted by the service provider is ready for signing. An email invitation has been sent to each signer to digitally sign the document.',
                },
                NOTARY: {
                    TITLE: 'Wait for signing the documents by the signers',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Wait for signing the documents by the signers',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for signing the documents by the signers',
                },
            },
            COLLECT_FEEDBACK: {
                CLIENT: {
                    TITLE: 'Collect feedback',
                },
                NOTARY: {
                    TITLE: 'Collect feedback',
                    DESCRIPTION: 'Client will give feedback.',
                },
                SUPPORT: {
                    TITLE: 'Collect feedback',
                    DESCRIPTION: 'Client will give feedback.',
                },
                BOOKKEEPER: {
                    TITLE: 'Collect feedback',
                    DESCRIPTION: 'Client will give feedback.',
                },
            },
            SUCCESSFUL: {
                DIGITAL_SHR: 'to open the organization overview.',
                CLIENT: {
                    TITLE: 'Procedure completed',
                },
                NOTARY: {
                    TITLE: 'Procedure completed',
                    DESCRIPTION: 'The procedure is completed. Many thanks for your excellent service!',
                },
                SUPPORT: {
                    TITLE: 'Procedure completed',
                    DESCRIPTION: 'The procedure is completed. Many thanks for your excellent service!',
                },
                BOOKKEEPER: {
                    TITLE: 'Procedure completed',
                    DESCRIPTION: 'The procedure is completed. Many thanks for your excellent service!',
                },
            },
            CANCELLED: {
                CLIENT: {
                    TITLE: 'The application has been canceled',
                },
                NOTARY: {
                    TITLE: 'The application has been canceled',
                },
                SUPPORT: {
                    TITLE: 'The application has been canceled',
                },
                BOOKKEEPER: {
                    TITLE: 'The application has been canceled',
                },
            },
            WAIT_FOR_PAYMENT_EXTRA: {
                SUPPORT: {
                    TITLE: 'Waiting for extra payment',
                },
                CLIENT: {
                    TITLE: 'Waiting for extra payment',
                },
                NOTARY: {
                    TITLE: 'Waiting for extra payment',
                },
            },
            REQUEST_DOCUMENTS: {
                SUPPORT: {
                    TITLE: 'Waiting for submission of required documents',
                    DESCRIPTION: 'The client received an email to upload the request documents. The following documents have been requested:',
                },
                CLIENT: {
                    TITLE: 'Submit requested documents',
                },
                NOTARY: {
                    TITLE: 'Waiting for submission of required documents',
                    DESCRIPTION: 'The client received an email to upload the request documents. The following documents have been requested:',
                },
                BOOKKEEPER: {
                    TITLE: 'Submit requested documents',
                },
            },
            WAIT_FOR_FORM: {
                SUPPORT: {
                    TITLE: 'Wait for form',
                    DESCRIPTION:
                        'The client first fills in the questionnaire for the specific application. After this, you will receive the answers in a PDF document attached to files.',
                },
                CLIENT: {
                    TITLE: 'Wait for form',
                },
                NOTARY: {
                    TITLE: 'Wait for form',
                    DESCRIPTION:
                        'The client first fills in the questionnaire for the specific application. After this, you will receive the answers in a PDF document attached to files.',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for form',
                },
            },
            REQUEST_INITIAL_OFFER: {
                SUPPORT: {
                    TITLE: 'Requested initial offer',
                    DESCRIPTION:
                        'The client has requested an initial offer. Please analyze the requested service and provide the client with a quote for the service.',
                },
                CLIENT: {
                    TITLE: 'Wait for initial offer',
                    DESCRIPTION: "The notary will analyze your request and prepare an offer for the service. Once the offer it's ready you will see it here.",
                },
                NOTARY: {
                    TITLE: 'Requested initial offer',
                    DESCRIPTION:
                        'The client has requested an initial offer. Please analyze the requested service and provide the client with a quote for the service.',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for initial offer',
                    DESCRIPTION: "The notary will analyze your request and prepare an offer for the service. Once the offer it's ready you will see it here.",
                },
            },
        },
        INCORPORATION: {
            OPEN_FREE_BUSINESS_BANK_ACCOUNT: {
                SUPPORT: {
                    TITLE: 'Open a bank account',
                },
            },
            COMPLETE_JOB: {
                CLIENT: {
                    TITLE: 'Job in progress',
                },
                NOTARY: {
                    TITLE: 'Job in progress',
                },
                SUPPORT: {
                    TITLE: 'Job in progress',
                },
                BOOKKEEPER: {
                    TITLE: 'Job in progress',
                },
            },
            REVIEW_JOB: {
                CLIENT: {
                    TITLE: 'Confirm job completion',
                },
                NOTARY: {
                    TITLE: 'Review job',
                },
                SUPPORT: {
                    TITLE: 'Review job',
                },
                BOOKKEEPER: {
                    TITLE: 'Confirm job completion',
                },
            },
            WAIT_FOR_PAYMENT_RETAINER: {
                CLIENT: {
                    TITLE: 'Retainer payment intake interview',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Retainer payment intake interview',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Retainer payment intake interview',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Retainer payment intake interview',
                    DESCRIPTION: '',
                },
            },
            REVIEW_APPLICATION: {
                CLIENT: {
                    TITLE: 'Review application',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Review application',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Review application',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Review application',
                    DESCRIPTION: '',
                },
            },
            PLAN_INTERVIEW: {
                CLIENT: {
                    TITLE: 'Schedule an appointment in the agenda',
                },
                NOTARY: {
                    TITLE: 'Waiting for customer to make an appointment',
                },
                SUPPORT: {
                    TITLE: 'Waiting for customer to make an appointment',
                },
                BOOKKEEPER: {
                    TITLE: 'Schedule an appointment in the agenda',
                },
            },
            INTERVIEW_OVERVIEW: {
                CLIENT: {
                    TITLE: 'Appointment is scheduled',
                },
                NOTARY: {
                    TITLE: 'Appointment is scheduled',
                },
                SUPPORT: {
                    TITLE: 'Appointment is scheduled',
                },
                BOOKKEEPER: {
                    TITLE: 'Appointment is scheduled',
                },
            },
            PROCESS_JOB: {
                CLIENT: {
                    TITLE: 'Application in progress',
                },
                NOTARY: {
                    TITLE: 'Application in progress',
                },
                SUPPORT: {
                    TITLE: 'Application in progress',
                },
                BOOKKEEPER: {
                    TITLE: 'Application in progress',
                },
            },
            WAIT_FOR_REVIEW_JOB: {
                CLIENT: {
                    TITLE: 'Wait for approval milestones',
                },
                NOTARY: {
                    TITLE: 'Wait for approval milestones',
                },
                SUPPORT: {
                    TITLE: 'Wait for approval milestones',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for approval milestones',
                },
            },
            RESUBMIT_RESULT: {
                CLIENT: {
                    TITLE: 'Upload new milestone result',
                },
                NOTARY: {
                    TITLE: 'Upload new milestone result',
                },
                SUPPORT: {
                    TITLE: 'Upload new milestone result',
                },
                BOOKKEEPER: {
                    TITLE: 'Upload new milestone result',
                },
            },
            ASSIGN_SERVICE_PROVIDER: {
                CLIENT: {
                    TITLE: 'The application has been rejected by the service provider',
                },
                NOTARY: {
                    TITLE: 'The application has been rejected by the service provider',
                },
                SUPPORT: {
                    TITLE: 'Review the rejection by the service provider',
                },
                BOOKKEEPER: {
                    TITLE: 'The application has been rejected by the service provider',
                },
            },
            INTAKE_INTERVIEW: {
                CLIENT: {
                    TITLE: 'Intake interview',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Intake interview',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Intake interview',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Intake interview',
                    DESCRIPTION: '',
                },
            },
            REVIEW_MILESTONE: {
                CLIENT: {
                    TITLE: 'Review milestone',
                },
                NOTARY: {
                    TITLE: 'Review milestone',
                },
                SUPPORT: {
                    TITLE: 'Review milestone',
                },
                BOOKKEEPER: {
                    TITLE: 'Review milestone',
                },
            },
            WAIT_FOR_PAYMENT_QUOTE: {
                CLIENT: {
                    TITLE: 'Payment quote',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Payment quote',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Payment quote',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Payment quote',
                    DESCRIPTION: '',
                },
            },
            VERIFY_ORGANIZATION: {
                CLIENT: {
                    TITLE: 'Verification for application',
                    DESCRIPTION:
                        'For the digital identification we need the following data per person. Please enter the details of all persons who need to be identified below.',
                },
                NOTARY: {
                    TITLE: 'Verification for application',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Verification for application',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'KYC onboarding',
                    DESCRIPTION: '',
                },
            },
            UPLOAD_RESULT: {
                CLIENT: {
                    TITLE: 'Job completion',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Job completion',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Job completion',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Job completion',
                    DESCRIPTION: '',
                },
            },
            EDIT_DETAILS: {
                CLIENT: {
                    TITLE: 'Your application is being processed',
                    DESCRIPTION:
                        '{tenant} is preparing the documents. We will keep you informed about the status of the liquidation. If you need to take action, you will be notified by email. So please keep an eye on your mailbox.',
                },
                SUPPORT: {
                    TITLE: 'Preparing the documents',
                    DESCRIPTION:
                        'An employee of {tenant} is preparing the documents. We will keep you informed about the status of the liquidation. If you need to take an action, you will be notified by email. So please keep an eye on your mailbox.',
                },
                NOTARY: {
                    TITLE: 'Fill in details',
                },
            },
            SIGN_BY_HAND: {
                CLIENT: {
                    TITLE: 'Send documents to {tenant}',
                    DESCRIPTION: 'Download, print, sign and send the delivered documents by post to {tenant}.',
                },
                SUPPORT: {
                    TITLE: 'Wait for signed documents',
                    DESCRIPTION: 'Print, sign and send the delivered documents by post to {tenant}.',
                },
                NOTARY: {
                    TITLE: 'Wait for signed documents',
                    DESCRIPTION: 'Print, sign and send the delivered documents by post to {tenant}.',
                },
                BOOKKEEPER: {
                    TITLE: 'Send documents to {tenant}',
                    DESCRIPTION: 'Download, print, sign and send the delivered documents by post to {tenant}.',
                },
            },
            APPROVE_DOCUMENT: {
                CLIENT: {
                    TITLE: 'Wait for confirmation by {tenant}',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Send documents to Chamber of Commerce',
                },
                SUPPORT: {
                    TITLE: 'Send documents to Chamber of Commerce',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for confirmation by {tenant}',
                    DESCRIPTION: '',
                },
            },
            DEREGISTER_COMPANY: {
                CLIENT: {
                    TITLE: 'Deregister company',
                    DESCRIPTION: 'The company {company} is being deregistered.',
                },
                NOTARY: {
                    TITLE: 'Check the Chamber of Commerce for an update',
                    DESCRIPTION: 'Check the Chamber of Commerce for an update and give notice to the client when {company} is deregistered.',
                },
                SUPPORT: {
                    TITLE: 'Check the Chamber of Commerce for an update',
                    DESCRIPTION: 'Check the Chamber of Commerce for an update and give notice to the client when {company} is deregistered.',
                },
                BOOKKEEPER: {
                    TITLE: 'Deregister company',
                    DESCRIPTION: 'The company {company} is being deregistered.',
                },
            },
            WAITING_PURCHASE_INSURANCE: {
                CLIENT: {
                    TITLE: 'Calculate insurance premium',
                    DESCRIPTION:
                        'Calculate in a few steps the monthly premium for your insurance. To calculate the premium, we need some information about your company.',
                },
                NOTARY: {
                    TITLE: 'Calculate insurance premium',
                    DESCRIPTION: 'Wait for client to take out an insurance policy',
                },
                SUPPORT: {
                    TITLE: 'Calculate insurance premium',
                    DESCRIPTION: 'Wait for client to take out an insurance policy',
                },
                BOOKKEEPER: {
                    TITLE: 'Calculate insurance premium',
                    DESCRIPTION:
                        'Calculate in a few steps the monthly premium for your insurance. To calculate the premium, we need some information about your company.',
                },
            },
            SUBMIT_DETAILS: {
                CLIENT: {
                    TITLE: 'Client fills out data',
                },
                NOTARY: {
                    TITLE: 'Client fills out data',
                },
                SUPPORT: {
                    TITLE: 'Client fills out data',
                },
                BOOKKEEPER: {
                    TITLE: 'Client fills out data',
                },
            },
            WAIT_FOR_PAYMENT: {
                CLIENT: {
                    TITLE: 'Waiting for payment',
                },
                NOTARY: {
                    TITLE: 'Waiting for payment',
                },
                SUPPORT: {
                    TITLE: 'Waiting for payment',
                },
                BOOKKEEPER: {
                    TITLE: 'Waiting for payment',
                },
            },
            WAIT_FOR_PAYMENT_INCORPORATION: {
                CLIENT: {
                    TITLE: 'Waiting for payment',
                },
                NOTARY: {
                    TITLE: 'Waiting for payment',
                },
                SUPPORT: {
                    TITLE: 'Waiting for payment',
                },
                BOOKKEEPER: {
                    TITLE: 'Waiting for payment',
                },
            },
            SUBMIT_ADDITIONAL_DETAILS: {
                CLIENT: {
                    TITLE: 'Submit additional details',
                },
                NOTARY: {
                    TITLE: 'Submit additional details',
                },
                SUPPORT: {
                    TITLE: 'Submit additional details',
                },
                BOOKKEEPER: {
                    TITLE: 'Submit additional details',
                },
            },
            SUBMIT_EXTRA_INFORMATION: {
                CLIENT: {
                    TITLE: 'Submit additional details',
                },
                NOTARY: {
                    TITLE: 'Submit additional details',
                },
                SUPPORT: {
                    TITLE: 'Submit additional details',
                },
                BOOKKEEPER: {
                    TITLE: 'Submit additional details',
                },
            },
            WAIT_FOR_IDENTIFICATION: {
                CLIENT: {
                    TITLE: 'Complete digital identification',
                    DESCRIPTION:
                        'Before the notary can start the incorporation, all founder(s) must identify themselves digitally. An invitation has been sent to every founder with a link to start the digital identification. If the mail has not arrived correctly, you can still change the email address. The invitation will be automatically resent.',
                },
                NOTARY: {
                    TITLE: 'Complete digital identification',
                    DESCRIPTION:
                        'Each person has received an invitation by email for the digital identification. You can easily change a shareholder’s email address or phone number as long as the identification has not been completed. The applicant can also do this themselves.',
                },
                SUPPORT: {
                    TITLE: 'Complete digital identification',
                    DESCRIPTION:
                        'Each person has received an invitation by email for the digital identification. You can easily change a shareholder’s email address or phone number as long as the identification has not been completed. The applicant can also do this themselves.',
                },
                BOOKKEEPER: {
                    TITLE: 'Complete digital identification',
                    DESCRIPTION:
                        'Each person has received an invitation by email for the digital identification. You can easily change a shareholder’s email address or phone number as long as the identification has not been completed. The applicant can also do this themselves.',
                },
            },
            UPLOAD_TAXES: {
                DECLINE_DOCUMENT_DESCRIPTION:
                    'The fiscal documents have been uploaded and can be found under - Documents -. Download and view the documents. If the documents are not correct, click on the button to refuse the documents. The customer must then upload all documents again. Also provide feedback in chat for the customer.',
                CLIENT: {
                    TITLE: 'Upload fiscal documents',
                },
                NOTARY: {
                    TITLE: 'Wait for fiscal documents',
                    DESCRIPTION:
                        'The online application has been completed. The next step is that the fiscal documents are uploaded. Based on the fiscal documents, you can draft the deed of incorporation, draft deed of transfer and power of attorney for each BV. {tenant} checks the documents and, if necessary, contacts the client or the (tax) advisor. When all the documents are correct, {tenant} will inform the notary to start the procedure.',
                },
                SUPPORT: {
                    TITLE: 'Wait for fiscal documents',
                    DESCRIPTION:
                        'The online application has been completed. The next step is that the fiscal documents are uploaded. Based on the fiscal documents, you can draft the deed of incorporation, draft deed of transfer and power of attorney for each BV. {tenant} checks the documents and, if necessary, contacts the client or the (tax) advisor. When all the documents are correct, {tenant} will inform the notary to start the procedure.',
                },
                BOOKKEEPER: {
                    TITLE: 'Upload fiscal documents',
                    DESCRIPTION:
                        'Congratulations, the online application has been completed! The next step is that the fiscal documents are uploaded. Based on the fiscal documents, the notary can draft the deed of incorporation, draft deed of transfer and power of attorney for each BV. {tenant} checks the documents and, if necessary, contacts you or your advisor.',
                },
            },
            UPLOAD_CONCEPT: {
                DISCUSS_OPTION_1: 'Discussing deed physically at notary office',
                DISCUSS_OPTION_2: 'Discussing deed via phone',
                CLIENT: {
                    TITLE: 'Waiting for review dossier',
                    DESCRIPTION: {
                        PART_1: 'The dossier is now with the notary. In the step of review dossier, the notary does the research and the draft deed, power of attorney and personal data card are prepared. The applicant will receive a notification by email to review the draft deed and all shareholders will receive a notification by e-mail to digitally sign the power of attorney.',
                        PART_2: {
                            SUB_PART_1: 'Please note: ',
                            SUB_PART_2: 'all dossiers are taken up by the notaries as soon as possible. Your dossier may remain on this step until ',
                            SUB_PART_3: 'the second last day',
                            SUB_PART_4:
                                '. Rest assured, the notary is working on your dossier and will upload the documents for approval and signature no later than this day. Once the notary discussed the deed with each shareholder (belehrung), the BV will be registered with the Chamber of Commerce.',
                        },
                        PART_3: 'Exception: The incorporation of a BV may be delayed if changes to the dossier are required, additional information is requested, and/or actions by the founder(s) are lacking. Ensure careful delivery of all required documents and respond quickly to requests to keep the process running smoothly.',
                    },
                },
                NOTARY: {
                    TITLE: 'Review dossier',
                    CLASSIFY_DOCUMENTS: 'Please classify the documents',
                    VALIDATION_ALL: 'Please select at least one document of each type Poa and Concept.',
                    VALIDATION_ALL_TRANSFER: 'Please select at least one document of each type Poa Concept and Transfer concept',
                    VALIDATION_RE_UPLOAD: 'Please select at least one document type Poa.',
                    VALIDATION_RE_UPLOAD_TRANSFER: 'Please select at least one document type Poa and Transfer',
                    RE_UPLOAD_TITLE: 'Seems that you have to re-upload the POA and PDC documents.',
                },
                SUPPORT: {
                    TITLE: 'Review dossier',
                },
                BOOKKEEPER: {
                    TITLE: 'Review dossier',
                },
            },
            UPLOAD_LIQUIDATION: {
                SUPPORT: {
                    VALIDATION_ALL: 'Please select at least one document of each type: Liquidation Resolution and Liquidation Kvk.',
                },
            },
            WAIT_FOR_PREPARE_SIGNING: {
                CLICK_TO_PREPARE: 'Prepare document',
                CLIENT: {
                    TITLE: 'Wait for prepare signing',
                    DESCRIPTION:
                        'The notary will prepare the signing of the documents. You will receive a notification by e-mail as soon as these documents are ready in your dashboard.',
                },
                NOTARY: {
                    TITLE: 'Wait for prepare signing',
                    DESCRIPTION:
                        'Wait for signing the documents by the shareholders. Uploaded the wrong document? Easily adjust the document and upload the correct one.',
                },
                SUPPORT: {
                    TITLE: 'Wait for prepare signing',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for prepare signing',
                },
            },
            APPROVE_CONCEPT: {
                CLIENT: {
                    TITLE: 'Approval draft deed of incorporation',
                    DESCRIPTION:
                        'The draft deed of incorporation is ready for your approval. Read the deed carefully. Pay particular attention to the first two pages (name and activities) and the last page (final statements). Is everything correct? Please approve the draft to proceed to the next step. If something is not correct, please send the notary a message. See - Messages - below.',
                },
                NOTARY: {
                    TITLE: 'Waiting for approval draft deed of incorporation',
                    DESCRIPTION:
                        'The applicant has received the draft deed, reviews it and will then approve the deed. An explanation of the draft deed has also been sent for additional information. If the applicant has already approved the draft deed during the meeting, you can approve the deed yourself.',
                },
                SUPPORT: {
                    TITLE: 'Approve concept',
                },
                BOOKKEEPER: {
                    TITLE: 'Waiting for approval draft deed of incorporation',
                },
            },
            DOSSIER_QUEUED: {
                CLIENT: {
                    TITLE: 'Dossier has been submitted to the notary',
                    DESCRIPTION: {
                        PARAGRAPH_1:
                            "The dossier has been submitted to the notary. Your dossier enters the notary's queue. The notary handles the dossier in the order in which they are received. This may mean a short waiting period before it is your dossier’s turn. In case of an accelerated procedure or an urgent request, your dossier will be given priority.",
                        PARAGRAPH_2:
                            'You will receive an e-mail notification as soon as the notary takes up your dossier. At the top right of the dossier, you will see the expected incorporation date. Please note that this is the turnaround time in business days and takes account of public holidays and weekends in the Netherlands.',
                        PARAGRAPH_3: {
                            PART_1: 'Please note',
                            PART_2: 'that all dossiers are taken up by the notaries as soon as possible. Your dossier may remain on this step',
                            PART_3: 'until the second last day.',
                            PART_4: 'Rest assured, the notary can complete the incorporation and submit it to the Chamber of Commerce within 1 business day.',
                        },
                        PARAGRAPH_4: {
                            PART_1: 'Exception:',
                            PART_2: 'The incorporation of a BV may be delayed if changes to the dossier are required, additional information is requested, and/or actions by the founder(s) are lacking. Ensure careful delivery of all required documents and respond quickly to requests to keep the process running smoothly.',
                        },
                    },
                },
                NOTARY: {
                    TITLE: 'Dossier has been submitted to the notary',
                    DESCRIPTION: {
                        PARAGRAPH_1:
                            'The online application has been completed, digital identification has been completed and any additional documents have been uploaded. The dossier has now been registered with you. Download the dossier and then press the button so that you process the dossier. The client will receive an email notification that the dossier has been processed.',
                        PARAGRAPH_2: {
                            PART_1: 'Please note:',
                            PART_2: 'while the dossier is not being processed, the client can still make changes, the dossier can be moved and no amount will be attached to the notary in case of a cancellation.',
                        },
                    },
                    DOSSIER_SUBMITTED: 'Dossier submitted',
                    DOSSIER_SUBMITTED_OFFICE_VISIT: 'Dossier submitted – client on location',
                    OFFICE_VISIT_FAILED: 'The dossier is in progress, but the office visit request failed. Request it again from the next step.',
                },
                SUPPORT: {
                    TITLE: 'Dossier has been submitted to the notary',
                },
                BOOKKEEPER: {
                    TITLE: 'Dossier has been submitted to the notary',
                },
            },
            REVIEW_DOSSIER: {
                BOOKKEEPER: {
                    TITLE: 'Review UBO application',
                    DESCRIPTION:
                        'The notary has received the application, will check the application and will proceed with the procedure. You will receive a notification by e-mail as soon as the application is submitted to the UBO register.',
                },
                CLIENT: {
                    TITLE: 'Review UBO application',
                    DESCRIPTION:
                        'The notary has received the application, will check the application and will proceed with the procedure. You will receive a notification by e-mail as soon as the application is submitted to the UBO register.',
                },
                NOTARY: {
                    TITLE: 'Review UBO application',
                },
                SUPPORT: {
                    TITLE: 'Review UBO application',
                },
            },
            FINISH_REGISTRATION: {
                BOOKKEEPER: {
                    TITLE: 'Confirm UBO registration',
                    DESCRIPTION:
                        'The application for UBO registration has been submitted to the UBO register. You will receive a notification by e-mail as soon as the registration is confirmed.',
                },
                CLIENT: {
                    TITLE: 'Confirm UBO registration',
                    DESCRIPTION:
                        'The application for UBO registration has been submitted to the UBO register. You will receive a notification by e-mail as soon as the registration is confirmed.',
                },
                NOTARY: {
                    TITLE: 'Confirm UBO registration',
                },
                SUPPORT: {
                    TITLE: 'Confirm UBO registration',
                },
            },
            WAIT_FOR_SIGNING: {
                CLIENT: {
                    TITLE: 'Signing power of attorney',
                    DESCRIPTION:
                        'The power of attorney has been drafted by the notary is ready for signature. An email invitation has been sent to each founder to digitally sign the power of attorney.',
                },
                NOTARY: {
                    TITLE: 'Wait for signing the documents by the shareholders',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Wait for signing the documents by the shareholders',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for signing the documents by the shareholders',
                },
            },
            WAIT_FOR_PROCESSES: {
                BOOKKEEPER: {
                    TITLE: 'Waiting to complete UBO registration(s)',
                    DESCRIPTION:
                        'Thank you for completing the request. The notary will process the application. If you have submitted the application for several BVs, you will see the application procedure per BV in the overview.',
                },
                CLIENT: {
                    TITLE: 'Waiting to complete UBO registration(s)',
                    DESCRIPTION:
                        'Thank you for completing the request. The notary will process the application. If you have submitted the application for several BVs, you will see the application procedure per BV in the overview.',
                },
                NOTARY: {
                    TITLE: 'Waiting to complete UBO registration(s)',
                    DESCRIPTION:
                        'Thank you for completing the request. The notary will process the application. If you have submitted the application for several BVs, you will see the application procedure per BV in the overview.',
                },
                SUPPORT: {
                    TITLE: 'Waiting to complete UBO registration(s)',
                    DESCRIPTION:
                        'Thank you for completing the request. The notary will process the application. If you have submitted the application for several BVs, you will see the application procedure per BV in the overview.',
                },
            },
            CONFIRM_DISCUSSION: {
                ACTION: 'Confirm discussion',
                CLIENT: {
                    TITLE: 'Waiting for discussion deed of incorporation',
                    DESCRIPTION:
                        'The notary will discuss the deed of incorporation with all the founders. This will be done digitally, by phone or at the office at the notary. The notary decides this. Please make an appointment with the notary. Here you will find the contact details.',
                },
                NOTARY: {
                    TITLE: 'Discussion deed of incorporation',
                    DESCRIPTION:
                        'The deed is approved. Please discuss the deed with all the founders. The client will contact your office to plan the meeting to discuss the deed. When the deed is already discussed, please click to continue to the next step.',
                },
                SUPPORT: {
                    TITLE: 'Discussion deed of incorporation',
                    DESCRIPTION:
                        'The deed is approved. Please discuss the deed with all the founders. The client will contact your office to plan the meeting to discuss the deed. When the deed is already discussed, please click to continue to the next step.',
                },
                BOOKKEEPER: {
                    TITLE: 'Discussion deed of incorporation',
                    DESCRIPTION:
                        'The deed is approved. Please discuss the deed with all the founders. The client will contact your office to plan the meeting to discuss the deed. When the deed is already discussed, please click to continue to the next step.',
                },
            },
            FINALIZE_DEED: {
                PASS_DATE: 'Pass date',
                USE_ACTUAL_PASS_DATE: 'Use pass date in past as payout date',
                VALIDATION: 'Please select at least one document of type Deed.',
                RE_UPLOAD: 'Upload new final deed',
                CLIENT: {
                    TITLE: 'Waiting for final deed of incorporation',
                    DESCRIPTION:
                        'The notary will pass the final deed of incorporation and will upload the document in your dashboard. After passing the final deed, the {entity} is formally incorporated. The notary will  then register the {entity} at the Business Register of the Chamber of Commerce and the UBO register.',
                },
                NOTARY: {
                    TITLE: 'Upload final deed of incorporation',
                    DESCRIPTION:
                        'The draft deed has been discussed and the deed can be passed. Upload the passed deed of incorporation in the portal to indicate to the client that the {entity} has been formally incorporated and that the registration is with the Chamber of Commerce. The client will receive a notification for this.',
                },
                SUPPORT: {
                    TITLE: 'Upload final deed of incorporation',
                    DESCRIPTION:
                        'The draft deed has been discussed and the deed can be passed. Upload the passed deed of incorporation in the portal to indicate to the client that the BV has been formally incorporated and that the registration is with the Chamber of Commerce. The client will receive a notification for this.',
                },
                BOOKKEEPER: {
                    TITLE: 'Upload final deed of incorporation',
                    DESCRIPTION:
                        'The draft deed has been discussed and the deed can be passed. Upload the passed deed of incorporation in the portal to indicate to the client that the BV has been formally incorporated and that the registration is with the Chamber of Commerce. The client will receive a notification for this.',
                },
            },
            REGISTER_KVK: {
                RSIN_NUMBER: 'RSIN number',
                VALIDATION: 'Please select at least one document of type Kvk and one Shareholder registry.',
                SELECT_REGISTERED_COMPANY: 'Please select the entity from the CoC registry:',
                SBI_CODES: 'Fill in the SBI code(s) of the company. Press enter to fill in the next one.',
                MAIN_ACTIVITY: 'What is the main activity of the BV?',
                MAIN_ACTIVITY_PREFIX: 'Conducting a business in the field of "{activity}"',
                CLIENT: {
                    TITLE: 'Waiting for registration by Chamber of Commerce',
                    DESCRIPTION:
                        'The notary will register the BV at the Business Register of the Chamber of Commerce and the UBO register. After the registration by the Chamber of Commerce you will receive the extract and the Chamber of Commerce number in your dashboard. The Chamber of Commerce automatically will send the registration to the Tax Authorities. After 1-2 weeks you will receive a letter at the company address with the VAT number (if applicable).',
                },
                NOTARY: {
                    TITLE: 'Complete procedure',
                },
                SUPPORT: {
                    TITLE: 'Complete procedure',
                },
                BOOKKEEPER: {
                    TITLE: 'Complete procedure',
                },
            },
            COLLECT_FEEDBACK: {
                CLIENT: {
                    TITLE: 'Collect feedback',
                },
                NOTARY: {
                    TITLE: 'Collect feedback',
                    DESCRIPTION: 'Client will give feedback.',
                },
                SUPPORT: {
                    TITLE: 'Collect feedback',
                    DESCRIPTION: 'Client will give feedback.',
                },
                BOOKKEEPER: {
                    TITLE: 'Collect feedback',
                    DESCRIPTION: 'Client will give feedback.',
                },
            },
            WAIT_FOR_UPSELL: {
                CLIENT: {
                    TITLE: 'Wait for holding procedure to be registered',
                    DESCRIPTION:
                        'The procedure(s) of the corresponding holding company or companies must first be registered, in order for the notary to complete the procedure of this BV. Please wait.',
                },
                NOTARY: {
                    TITLE: 'Wait for holding procedure to be registered',
                    DESCRIPTION:
                        'The procedure(s) of the corresponding holding company or companies must first be registered in order to complete the procedure of this BV.',
                },
                SUPPORT: {
                    TITLE: 'Wait for holding procedure to be registered',
                    DESCRIPTION:
                        'The procedure(s) of the corresponding holding company or companies must first be registered in order to complete the procedure of this BV.',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for holding procedure to be registered',
                    DESCRIPTION:
                        'The procedure(s) of the corresponding holding company or companies must first be registered in order to complete the procedure of this BV.',
                },
            },
            // Titles only: the card header and the stepper build this key dynamically from the state, so
            // they have to resolve globally. The descriptions live in IncorporationWaitForParentProcess.vue.
            WAIT_FOR_PARENT_PROCESS: {
                CLIENT: { TITLE: 'Waiting for the incorporation' },
                NOTARY: { TITLE: 'Waiting for the incorporation' },
                SUPPORT: { TITLE: 'Waiting for the incorporation' },
                BOOKKEEPER: { TITLE: 'Waiting for the incorporation' },
            },
            NOTARY_CHECK: {
                CLIENT: {
                    TITLE: 'Notary check',
                    DESCRIPTION: "The notary will check all the information before it's processed in the organization overview.",
                },
                NOTARY: {
                    TITLE: 'Notary check',
                    DESCRIPTION: 'Check if all the information is correct, so that the right information will be processed in the organization overview.',
                },
                SUPPORT: {
                    TITLE: 'Notary check',
                    DESCRIPTION: 'Check if all the information is correct, so that the right information will be processed in the organization overview.',
                },
                BOOKKEEPER: {
                    TITLE: 'Notary check',
                    DESCRIPTION: 'Check if all the information is correct, so that the right information will be processed in the organization overview.',
                },
            },
            SUCCESSFUL: {
                DIGITAL_SHR: 'to open the organization overview.',
                CLIENT: {
                    TITLE: 'Procedure completed',
                },
                NOTARY: {
                    TITLE: 'Procedure completed',
                    DESCRIPTION: 'The procedure is completed. Many thanks for your excellent service!',
                },
                SUPPORT: {
                    TITLE: 'Procedure completed',
                    DESCRIPTION: 'The procedure is completed. Many thanks for your excellent service!',
                },
                BOOKKEEPER: {
                    TITLE: 'Procedure completed',
                    DESCRIPTION: 'The procedure is completed. Many thanks for your excellent service!',
                },
            },
            CANCELLED: {
                CLIENT: {
                    TITLE: 'The application has been canceled',
                },
                NOTARY: {
                    TITLE: 'The application has been canceled',
                },
                SUPPORT: {
                    TITLE: 'The application has been canceled',
                },
                BOOKKEEPER: {
                    TITLE: 'The application has been canceled',
                },
            },
            WAIT_FOR_PAYMENT_EXTRA: {
                SUPPORT: {
                    TITLE: 'Waiting for extra payment',
                },
                CLIENT: {
                    TITLE: 'Waiting for extra payment',
                },
                NOTARY: {
                    TITLE: 'Waiting for extra payment',
                },
            },
            REQUEST_DOCUMENTS: {
                SUPPORT: {
                    TITLE: 'Waiting for submission of required documents',
                    DESCRIPTION: 'The client received an email to upload the request documents. The following documents have been requested:',
                },
                CLIENT: {
                    TITLE: 'Submit requested documents',
                },
                NOTARY: {
                    TITLE: 'Waiting for submission of required documents',
                    DESCRIPTION: 'The client received an email to upload the request documents. The following documents have been requested:',
                },
                BOOKKEEPER: {
                    TITLE: 'Submit requested documents',
                },
            },
            REQUEST_CLIENT_INFORMATION: {
                SUPPORT: {
                    TITLE: 'Waiting for the client to make contact',
                },
                CLIENT: {
                    TITLE: 'The notary would like to speak to you',
                },
                NOTARY: {
                    TITLE: 'Waiting for the client to make contact',
                },
                BOOKKEEPER: {
                    TITLE: 'The notary would like to speak to the client',
                },
            },
            WAIT_FOR_FORM: {
                SUPPORT: {
                    TITLE: 'Wait for form',
                },
                CLIENT: {
                    TITLE: 'Wait for form',
                },
                NOTARY: {
                    TITLE: 'Wait for form',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for form',
                },
            },
            POST_SALE_UPSELL: {
                SUPPORT: {
                    TITLE: 'Open a free business bank account',
                    DESCRIPTION: 'Wait for the client to finish the GoDutch process.',
                },
                CLIENT: {
                    TITLE: 'Open a free business bank account',
                },
                NOTARY: {
                    TITLE: 'Open a free business bank account',
                },
                BOOKKEEPER: {
                    TITLE: 'Open a free business bank account',
                },
            },
            SUBMIT_OFFER: {
                SUPPORT: {
                    TITLE: 'Upload an offer',
                },
                CLIENT: {
                    TITLE: 'The accountant will upload an offer',
                },
                NOTARY: {
                    TITLE: 'Upload an offer',
                },
            },
            REVIEW_OFFER: {
                SUPPORT: {
                    TITLE: 'The client is reviewing the offer',
                },
                CLIENT: {
                    TITLE: 'Check the offer from the accountant',
                },
                NOTARY: {
                    TITLE: 'The client is reviewing the offer',
                },
            },
            WAIT_FOR_PAYMENT_PRODUCT: {
                SUPPORT: {
                    TITLE: 'Waiting for payment',
                },
                CLIENT: {
                    TITLE: 'Waiting for payment',
                },
                NOTARY: {
                    TITLE: 'Waiting for payment',
                },
            },
            SUBMIT_PRODUCT_INFO: {
                SUPPORT: {
                    TITLE: 'Submit additional information',
                },
                CLIENT: {
                    TITLE: 'Submit additional information',
                },
                NOTARY: {
                    TITLE: 'Submit additional information',
                },
            },
            SUB_PROCESSES: 'Sub processes',
            PARENT_PROCESS: 'Parent process',
            CURRENT_STATUS_TITLE: 'Current status of incorporation',
            STEP_TITLE: 'Step',
            INCORPORATION_LIVE: 'Congratulations, your BV is now live!',
            GO_TO_DASHBOARD: 'View your incorporations',
            RELATED_PROCESS: 'Related process',
            CURRENT_STEP: 'Current step',
            CHANGE_ORGANIZATION_NAME: 'Change organization name',
            SEND_A_REMINDER: 'Send a reminder',
            SKIP: 'Skip',
            RESET: 'Reset',
            REMOVE: 'Remove',
            APPROVE_THE_CONCEPT: 'Approve the concept',
            CHANGE_THE_CONCEPT: 'Request changes',
            REJECT_THE_CONCEPT: 'Reject the concept',
            REASON_REJECT_THE_CONCEPT: 'Indicate to the notary which changes are required',
            UPLOAD_NEW_CONCEPT_VERSION: 'Upload new concept version',
            MESSAGE_DESCRIPTION:
                'If the notary needs any information, he or she will contact you and send you a message. You will receive a notification per email. It is not necessary to send the notary a message about the status of the procedure. Automatic notifications are enabled for this.',
            MESSAGE_DESCRIPTION_NOTARY:
                'If you, as a notary, needs any information about the procedure, you can request this directly from the client. The client (and {tenant}) will be notified of the message and will contact you via this message. The client will not contact you about the course of the procedure. Automatic messages have been enabled for this.',
            POA: 'Poa',
            PDC: 'Pdc',
            CONCEPT: 'Concept deed',
            TRANSLATION: 'Translation',
            COVER_LETTER: 'Cover letter',
            LIQUIDATION_RESOLUTION: 'Liquidation Resolution',
            LIQUIDATION_KVK: 'Liquidation Kvk',
            OTHER: 'Other',
            DEED: 'Deed',
            TRANSFER_DEED: 'Transfer deed',
            TRANSFER_CONCEPT: 'Transfer Concept',
            PLEASE_FILL_IN: 'Please fill the information',
            IS_FULLY_PAID: 'Is fully paid',
            KVK: 'Extract Chamber of Commerce',
            SHR: 'Shareholder register',
            RESET_IDENTIFICATION: 'Reset identification',
            RESET_EXPLANATION:
                'Click the - Reset - button to resend the invitation for the digital identification. You can use this if a person has not identified him- or herself correctly. Select the person and click on “reset”',
            SKIP_EXPLANATION: 'You can use this if there are problems with the digital identification and the founders are directly identified by the notary.',
            SKIP_SIGNING_EXPLANATION: 'If the shareholders are coming to office to sign the power of attorney you can skip the digital signing',
            CONVERT_HOLDING: 'Convert shareholder to a holding upsell',
            CONVERT_HOLDING_EXPLANATION: 'This will start a holding sub process. Attention: The client needs to pay for the holding in advance',
            CONVERT_HOLDING_CONFIRM: 'convert shareholder to holding',
            RE_UPLOAD_DOCUMENT: 'Re-upload document',
            UBO: 'Ubo',
            PEP: 'Pep',
        },
        COLLECT_FEEDBACK: {
            QUESTION_1: {
                TITLE: 'Why did you choose {tenant}?',
                TOOLTIP: 'Multiple answers possible',
                COMPETITIVE_PRICE: 'Competitive price',
                DIGITAL_PROCESS: 'Fully digital process',
                REFERRED: 'Referred by someone else',
                TRANSPARENT_PROCESS: 'Transparent process',
                FAST_TURNAROUND_TIME: 'Fast turnaround time',
                OTHER: 'Other, namely',
            },
            QUESTION_2: 'What are you least satisfied with?',
            QUESTION_3: 'If you could improve something immediately, what would you adjust?',
            QUESTION_4: 'What else could we help you with your business?',
            QUESTION_5: {
                TITLE: 'Please rate the notary',
                TOOLTIP: '10 is perfect and 1 is bad',
            },
            QUESTION_6: 'Why do you give this grade?',
            QUESTION_7: {
                TITLE: 'Please rate the {tenant} service',
                TOOLTIP: '10 is perfect and 1 is bad',
            },
            WAIT_FEEDBACK_REVIEW: 'Please wait until we process your feedback.',
            CLIENT: {
                REVIEW_SERVICE_PROVIDER: 'Complete the procedure by reviewing your service provider.',
                RATE_SERVICE_PROVIDER: 'How would you rate the service provider?',
                REVIEW_NOTARY: 'Complete the procedure by reviewing your notary.',
                RATE_NOTARY: 'How would you rate the notary?',
                COMMENT_SERVICE_PROVIDER: 'Would you like to add a comment?',
            },
            SERVICE_PROVIDER: {
                REVIEW_SERVICE_PROVIDER:
                    'Complete the procedure by reviewing your client. After this the payment will be released to the bank account of your company.',
                RATE_SERVICE_PROVIDER: 'How would you rate your client?',
                COMMENT_SERVICE_PROVIDER: 'Would you like to add a comment?',
            },
        },
    },
    NL: {
        GENERAL_WORKFLOW: {
            COMPLETE_JOB: {
                CLIENT: {
                    TITLE: 'Job in uitvoering',
                },
                NOTARY: {
                    TITLE: 'Job in uitvoering',
                },
                SUPPORT: {
                    TITLE: 'Job in uitvoering',
                },
                BOOKKEEPER: {
                    TITLE: 'Job in uitvoering',
                },
            },
            REVIEW_JOB: {
                CLIENT: {
                    TITLE: 'Review aanvraag',
                },
                NOTARY: {
                    TITLE: 'Review aanvraag',
                },
                SUPPORT: {
                    TITLE: 'Review aanvraag',
                },
                BOOKKEEPER: {
                    TITLE: 'Bevestig afronding job',
                },
            },
            WAIT_FOR_PAYMENT_RETAINER: {
                CLIENT: {
                    TITLE: 'Betaling voorschot',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Betaling voorschot',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Betaling voorschot',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Betaling voorschot',
                    DESCRIPTION: '',
                },
            },
            REVIEW_APPLICATION: {
                CLIENT: {
                    TITLE: 'Review aanvraag',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Review aanvraag',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Review aanvraag',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Review aanvraag',
                    DESCRIPTION: '',
                },
            },
            PLAN_INTERVIEW: {
                CLIENT: {
                    TITLE: 'Plan een afspraak in de agenda',
                },
                NOTARY: {
                    TITLE: 'In afwachting op het maken van afspraak door klant',
                },
                SUPPORT: {
                    TITLE: 'In afwachting op het maken van afspraak door klant',
                },
                BOOKKEEPER: {
                    TITLE: 'Plan een afspraak in de agenda',
                },
            },
            INTERVIEW_OVERVIEW: {
                CLIENT: {
                    TITLE: 'De afspraak is ingepland',
                },
                NOTARY: {
                    TITLE: 'De afspraak is ingepland',
                },
                SUPPORT: {
                    TITLE: 'De afspraak is ingepland',
                },
                BOOKKEEPER: {
                    TITLE: 'De afspraak is ingepland',
                },
            },
            PROCESS_JOB: {
                CLIENT: {
                    TITLE: 'Aanvraag in behandeling',
                },
                NOTARY: {
                    TITLE: 'Aanvraag in behandeling',
                },
                SUPPORT: {
                    TITLE: 'Aanvraag in behandeling',
                },
                BOOKKEEPER: {
                    TITLE: 'Aanvraag in behandeling',
                },
            },
            WAIT_FOR_REVIEW_JOB: {
                CLIENT: {
                    TITLE: 'Wacht op goedkeuring van de milestones',
                },
                NOTARY: {
                    TITLE: 'Wacht op goedkeuring van de milestones',
                },
                SUPPORT: {
                    TITLE: 'Wacht op goedkeuring van de milestones',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op goedkeuring van de milestones',
                },
            },
            RESUBMIT_RESULT: {
                CLIENT: {
                    TITLE: 'Upload nieuw milestone resultaat',
                },
                NOTARY: {
                    TITLE: 'Upload nieuw milestone resultaat',
                },
                SUPPORT: {
                    TITLE: 'Upload nieuw milestone resultaat',
                },
                BOOKKEEPER: {
                    TITLE: 'Upload nieuw milestone resultaat',
                },
            },
            ASSIGN_SERVICE_PROVIDER: {
                CLIENT: {
                    TITLE: 'De aanvraag is afgewezen door de dienstverlener',
                },
                NOTARY: {
                    TITLE: 'De aanvraag is afgewezen door de dienstverlener',
                },
                SUPPORT: {
                    TITLE: 'Beoordeel de afwijzing door de dienstverlener',
                },
                BOOKKEEPER: {
                    TITLE: 'De aanvraag is afgewezen door de dienstverlener',
                },
            },
            INTAKE_INTERVIEW: {
                CLIENT: {
                    TITLE: 'Intake afspraak',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Intake afspraak',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Intake afspraak',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Intake afspraak',
                    DESCRIPTION: '',
                },
            },
            REVIEW_MILESTONE: {
                CLIENT: {
                    TITLE: 'Review milestone',
                },
                NOTARY: {
                    TITLE: 'Review milestone',
                },
                SUPPORT: {
                    TITLE: 'Review milestone',
                },
                BOOKKEEPER: {
                    TITLE: 'Review milestone',
                },
            },
            WAIT_FOR_PAYMENT_QUOTE: {
                CLIENT: {
                    TITLE: 'Betaling offerte',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Betaling offerte',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Betaling offerte',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Betaling offerte',
                    DESCRIPTION: '',
                },
            },
            VERIFY_ORGANIZATION: {
                CLIENT: {
                    TITLE: 'Verificatie voor aanvraag',
                    DESCRIPTION:
                        'Voor de digitale identificatie hebben we de volgende gegevens nodig per persoon. Vul hieronder de gegevens in van alle personen die geïdentificeerd moeten worden.',
                },
                NOTARY: {
                    TITLE: 'Verificatie voor aanvraag',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Verificatie voor aanvraag',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Verificatie voor aanvraag',
                    DESCRIPTION: '',
                },
            },
            UPLOAD_RESULT: {
                CLIENT: {
                    TITLE: 'Job afronding',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Job afronding',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Job afronding',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Job afronding',
                    DESCRIPTION: '',
                },
            },
            EDIT_DETAILS: {
                CLIENT: {
                    TITLE: 'Jouw aanvraag is in behandeling',
                    DESCRIPTION:
                        '{tenant} bereidt de documenten voor. Wij houden je op de hoogte over de status van de opheffing. Als je actie moet ondernemen, wordt je hiervan per e-mail op de hoogte gesteld. Houd daarom jouw mailbox in de gaten.',
                },
                NOTARY: {
                    TITLE: 'Invullen gegevens',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'De documenten voorbereiden',
                    DESCRIPTION:
                        'Een medewerker van {tenant} maakt de documenten gereed. Je wordt bij elke activiteit op de hoogte gesteld van de status van de opheffing. Als je actie dient te ondernemen, dan krijg je een notificatie hiervan per e-mail. Let dus goed op je mailbox.',
                },
                BOOKKEEPER: {
                    TITLE: 'Invullen gegevens',
                    DESCRIPTION: '',
                },
            },
            APPROVE_DOCUMENT: {
                CLIENT: {
                    TITLE: 'Wacht op bevestiging door {tenant}',
                },
                SUPPORT: {
                    TITLE: 'Documenten versturen naar KvK',
                },
                NOTARY: {
                    TITLE: 'Documenten versturen naar KvK',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op bevestiging door {tenant}',
                },
            },
            DEREGISTER_COMPANY: {
                CLIENT: {
                    TITLE: 'Deregister company',
                    DESCRIPTION: 'Het bedrijf {company} wordt uitgeschreven.',
                },
                SUPPORT: {
                    TITLE: 'Controleer de KvK voor een update',
                    DESCRIPTION: 'Check de KvK voor een update en informeer cliënt zodra {company} is uitgeschreven.',
                },
                NOTARY: {
                    TITLE: 'Controleer de KvK voor een update',
                    DESCRIPTION: 'Check de KvK voor een update en informeer cliënt zodra {company} is uitgeschreven.',
                },
                BOOKKEEPER: {
                    TITLE: 'Deregister company',
                    DESCRIPTION: 'Het bedrijf {company} wordt uitgeschreven.',
                },
            },
            SUBMIT_DETAILS: {
                CLIENT: {
                    TITLE: 'Cliënt vult de gegevens in',
                },
                NOTARY: {
                    TITLE: 'Cliënt vult de gegevens in',
                },
                SUPPORT: {
                    TITLE: 'Cliënt vult de gegevens in',
                },
                BOOKKEEPER: {
                    TITLE: 'Cliënt vult de gegevens in',
                },
            },
            WAIT_FOR_PAYMENT: {
                CLIENT: { TITLE: 'Wacht op betaling' },
                NOTARY: { TITLE: 'Wacht op betaling' },
                SUPPORT: { TITLE: 'Wacht op betaling' },
                BOOKKEEPER: { TITLE: 'Wacht op betaling' },
            },
            WAIT_FOR_PAYMENT_INCORPORATION: {
                CLIENT: { TITLE: 'Wacht op betaling' },
                NOTARY: { TITLE: 'Wacht op betaling' },
                SUPPORT: { TITLE: 'Wacht op betaling' },
                BOOKKEEPER: { TITLE: 'Wacht op betaling' },
            },
            SUBMIT_ADDITIONAL_DETAILS: {
                CLIENT: { TITLE: 'Aanvullende gegevens indienen' },
                NOTARY: { TITLE: 'Aanvullende gegevens indienen' },
                SUPPORT: { TITLE: 'Aanvullende gegevens indienen' },
                BOOKKEEPER: { TITLE: 'Aanvullende gegevens indienen' },
            },
            WAIT_FOR_IDENTIFICATION: {
                CLIENT: {
                    TITLE: 'Voltooi digitale identificatie',
                    DESCRIPTION:
                        'Voordat de dienstverlener de opdract kan starten dienen alle deelnemer(s) zich digitaal te identificeren. Er is een uitnodiging per email naar elke oprichter gestuurd met een link om de digitale identificatie te starten. Is de mail niet goed aangekomen dan kun je het emailadres nog aanpassen. De uitnodiging wordt automatisch opnieuw verstuurd.',
                },
                NOTARY: {
                    TITLE: 'Wacht op digitale identificatie van de oprichters',
                    DESCRIPTION:
                        'Elke persoon heeft uitnodiging per email ontvangen voor de digitale identificatie. Je kunt eenvoudig het e-mailadres of telefoonnummer wijzigen van een oprichter zolang de identificatie nog niet is voltooid. De aanvrager kan dit zelf ook doen.',
                },
                SUPPORT: {
                    TITLE: 'Wacht op digitale identificatie van de oprichters',
                    DESCRIPTION:
                        'Elke persoon heeft uitnodiging per email ontvangen voor de digitale identificatie. Je kunt eenvoudig het e-mailadres of telefoonnummer wijzigen van een oprichter zolang de identificatie nog niet is voltooid. De aanvrager kan dit zelf ook doen.',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op digitale identificatie van de oprichters',
                    DESCRIPTION:
                        'Elke persoon heeft uitnodiging per email ontvangen voor de digitale identificatie. Je kunt eenvoudig het e-mailadres of telefoonnummer wijzigen van een oprichter zolang de identificatie nog niet is voltooid. De aanvrager kan dit zelf ook doen.',
                },
            },
            UPLOAD_LIQUIDATION: {
                SUPPORT: {
                    VALIDATION_ALL: 'Selecteer ten minste één document van type: Liquidatie Resolutie en Liquidatie Kvk.',
                },
            },
            REVIEW_DOSSIER: {
                BOOKKEEPER: {
                    TITLE: 'Review UBO aanvraag',
                    DESCRIPTION:
                        'De notaris heeft de aanvraag ontvangen, controleert de aanvraag en gaat verder met de procedure. U ontvangt per e-mail een notificiatie zodra de aanvraag is ingediend bij het UBO-register.',
                },
                CLIENT: {
                    TITLE: 'Review UBO aanvraag',
                    DESCRIPTION:
                        'De notaris heeft de aanvraag ontvangen, controleert de aanvraag en gaat verder met de procedure. U ontvangt per e-mail een notificiatie zodra de aanvraag is ingediend bij het UBO-register.',
                },
                NOTARY: {
                    TITLE: 'Review UBO aanvraag',
                },
                SUPPORT: {
                    TITLE: 'Review UBO aanvraag',
                },
            },
            FINISH_REGISTRATION: {
                BOOKKEEPER: {
                    TITLE: 'Bevestig UBO registratie',
                    DESCRIPTION:
                        'De aanvraag voor UBO registratie is ingediend bij het UBO register. U ontvangt een bericht per e-mail zodra de registratie is bevestigd.',
                },
                CLIENT: {
                    TITLE: 'Bevestig UBO registratie',
                    DESCRIPTION:
                        'De aanvraag voor UBO registratie is ingediend bij het UBO register. U ontvangt een bericht per e-mail zodra de registratie is bevestigd.',
                },
                NOTARY: {
                    TITLE: 'Bevestig UBO registratie',
                },
                SUPPORT: {
                    TITLE: 'Bevestig UBO registratie',
                },
            },
            WAIT_FOR_PREPARE_SIGNING: {
                CLICK_TO_PREPARE: 'Bereid het document voor',
                CLIENT: {
                    TITLE: 'Wacht op voorbereiden ondertekening',
                    DESCRIPTION:
                        'De dienstverlener is de documenten aan het voorbereiden voor ondertekening. Je ontvangt per e-mail een notificatie zodra deze documenten klaar staan in jouw dashboard.',
                },
                NOTARY: {
                    TITLE: 'Wacht op voorbereiden ondertekening',
                    DESCRIPTION:
                        'Wacht op ondertekening door de aandeelhouders. Verkeerde document geupload? Verwijder eenvoudig het document aan en upload de correcte versie.',
                },
                SUPPORT: {
                    TITLE: 'Wacht op voorbereiden ondertekening',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op voorbereiden ondertekening',
                },
            },
            WAIT_FOR_SIGNING: {
                CLIENT: {
                    TITLE: 'Ondertekening documenten',
                    DESCRIPTION:
                        'Er is een document opgesteld door de dienstverlener en staat klaar voor ondertekening. Er is een uitnodiging per email naar elke ondertekenaar gestuurd om deze digitaal te ondertekenen.',
                },
                NOTARY: {
                    TITLE: 'Wacht op ondertekening door de ondertekenaars',
                },
                SUPPORT: {
                    TITLE: 'Wacht op ondertekening door de ondertekenaars',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op ondertekening door de ondertekenaars',
                },
            },
            COLLECT_FEEDBACK: {
                CLIENT: {
                    TITLE: 'Verzamel feedback',
                },
                NOTARY: {
                    TITLE: 'Verzamel feedback',
                    DESCRIPTION: 'Klant zal feedback geven.',
                },
                SUPPORT: {
                    TITLE: 'Verzamel feedback',
                    DESCRIPTION: 'Klant zal feedback geven.',
                },
                BOOKKEEPER: {
                    TITLE: 'Verzamel feedback',
                    DESCRIPTION: 'Klant zal feedback geven.',
                },
            },
            SUCCESSFUL: {
                DIGITAL_SHR: 'om het organisatieoverzicht te openen.',
                CLIENT: {
                    TITLE: 'Procedure voltooid',
                },
                NOTARY: {
                    TITLE: 'Procedure voltooid',
                    DESCRIPTION: 'De procedure is voltooid. Hartelijk bedankt voor de uitstekende service!',
                },
                SUPPORT: {
                    TITLE: 'Procedure voltooid',
                    DESCRIPTION: 'De procedure is voltooid. Hartelijk bedankt voor de uitstekende service!',
                },
                BOOKKEEPER: {
                    TITLE: 'Procedure voltooid',
                    DESCRIPTION: 'De procedure is voltooid. Hartelijk bedankt voor de uitstekende service!',
                },
            },
            CANCELLED: {
                CLIENT: {
                    TITLE: 'De aanvraag is geannuleerd',
                },
                NOTARY: {
                    TITLE: 'De aanvraag is geannuleerd',
                },
                SUPPORT: {
                    TITLE: 'De aanvraag is geannuleerd',
                },
                BOOKKEEPER: {
                    TITLE: 'De aanvraag is geannuleerd',
                },
            },
            WAIT_FOR_PAYMENT_EXTRA: {
                SUPPORT: {
                    TITLE: 'Wachten op extra betaling',
                },
                CLIENT: {
                    TITLE: 'Wachten op extra betaling',
                },
                NOTARY: {
                    TITLE: 'Wachten op extra betaling',
                },
            },
            REQUEST_DOCUMENTS: {
                SUPPORT: {
                    TITLE: 'Wachten op indiening van vereiste documenten',
                    DESCRIPTION: 'De cliënt heeft een email ontvangen om de aangevraagde documenten te uploaden. De volgende document zijn opgevraagd:',
                },
                CLIENT: {
                    TITLE: 'Dien gevraagde documenten in',
                },
                NOTARY: {
                    TITLE: 'Wachten op indiening van vereiste documenten',
                    DESCRIPTION: 'De cliënt heeft een email ontvangen om de aangevraagde documenten te uploaden. De volgende document zijn opgevraagd:',
                },
                BOOKKEEPER: {
                    TITLE: 'Dien gevraagde documenten in',
                },
            },
            WAIT_FOR_FORM: {
                SUPPORT: {
                    TITLE: 'Wacht op formulier',
                    DESCRIPTION:
                        'De cliënt vult eerst het vragenformulier in voor de specifieke opdracht. Hierna ontvang je de antwoorden in een PDF document bij bestanden.',
                },
                CLIENT: {
                    TITLE: 'Wacht op formulier',
                },
                NOTARY: {
                    TITLE: 'Wacht op formulier',
                    DESCRIPTION:
                        'De cliënt vult eerst het vragenformulier in voor de specifieke opdracht. Hierna ontvang je de antwoorden in een PDF document bij bestanden.',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op formulier',
                },
            },
            REQUEST_INITIAL_OFFER: {
                SUPPORT: {
                    TITLE: 'Gevraagd eerste bod',
                    DESCRIPTION:
                        'De cliënt heeft een eerste offerte aangevraagd. Analyseer de gevraagde service en geef de cliënt een offerte voor de service.',
                },
                CLIENT: {
                    TITLE: 'Wacht op het eerste bod',
                    DESCRIPTION: 'De notaris analyseert uw aanvraag en bereidt een aanbod voor de service voor. Zodra het aanbod klaar is, ziet u het hier.',
                },
                NOTARY: {
                    TITLE: 'Gevraagd eerste bod',
                    DESCRIPTION:
                        'De cliënt heeft een eerste offerte aangevraagd. Analyseer de gevraagde service en geef de cliënt een offerte voor de service.',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op het eerste bod',
                    DESCRIPTION: 'De notaris analyseert uw aanvraag en bereidt een aanbod voor de service voor. Zodra het aanbod klaar is, ziet u het hier.',
                },
            },
        },
        INCORPORATION: {
            OPEN_FREE_BUSINESS_BANK_ACCOUNT: {
                SUPPORT: {
                    TITLE: 'Open een bankrekening',
                },
            },
            COMPLETE_JOB: {
                CLIENT: {
                    TITLE: 'Job in uitvoering',
                },
                NOTARY: {
                    TITLE: 'Job in uitvoering',
                },
                SUPPORT: {
                    TITLE: 'Job in uitvoering',
                },
                BOOKKEEPER: {
                    TITLE: 'Job in uitvoering',
                },
            },
            REVIEW_JOB: {
                CLIENT: {
                    TITLE: 'Review aanvraag',
                },
                NOTARY: {
                    TITLE: 'Review aanvraag',
                },
                SUPPORT: {
                    TITLE: 'Review aanvraag',
                },
                BOOKKEEPER: {
                    TITLE: 'Bevestig afronding job',
                },
            },
            WAIT_FOR_PAYMENT_RETAINER: {
                CLIENT: {
                    TITLE: 'Betaling voorschot',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Betaling voorschot',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Betaling voorschot',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Betaling voorschot',
                    DESCRIPTION: '',
                },
            },
            REVIEW_APPLICATION: {
                CLIENT: {
                    TITLE: 'Review aanvraag',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Review aanvraag',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Review aanvraag',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Review aanvraag',
                    DESCRIPTION: '',
                },
            },
            PLAN_INTERVIEW: {
                CLIENT: {
                    TITLE: 'Plan een afspraak in de agenda',
                },
                NOTARY: {
                    TITLE: 'In afwachting op het maken van afspraak door klant',
                },
                SUPPORT: {
                    TITLE: 'In afwachting op het maken van afspraak door klant',
                },
                BOOKKEEPER: {
                    TITLE: 'Plan een afspraak in de agenda',
                },
            },
            INTERVIEW_OVERVIEW: {
                CLIENT: {
                    TITLE: 'De afspraak is ingepland',
                },
                NOTARY: {
                    TITLE: 'De afspraak is ingepland',
                },
                SUPPORT: {
                    TITLE: 'De afspraak is ingepland',
                },
                BOOKKEEPER: {
                    TITLE: 'De afspraak is ingepland',
                },
            },
            PROCESS_JOB: {
                CLIENT: {
                    TITLE: 'Aanvraag in behandeling',
                },
                NOTARY: {
                    TITLE: 'Aanvraag in behandeling',
                },
                SUPPORT: {
                    TITLE: 'Aanvraag in behandeling',
                },
                BOOKKEEPER: {
                    TITLE: 'Aanvraag in behandeling',
                },
            },
            WAIT_FOR_REVIEW_JOB: {
                CLIENT: {
                    TITLE: 'Wacht op goedkeuring van de milestones',
                },
                NOTARY: {
                    TITLE: 'Wacht op goedkeuring van de milestones',
                },
                SUPPORT: {
                    TITLE: 'Wacht op goedkeuring van de milestones',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op goedkeuring van de milestones',
                },
            },
            RESUBMIT_RESULT: {
                CLIENT: {
                    TITLE: 'Upload nieuw milestone resultaat',
                },
                NOTARY: {
                    TITLE: 'Upload nieuw milestone resultaat',
                },
                SUPPORT: {
                    TITLE: 'Upload nieuw milestone resultaat',
                },
                BOOKKEEPER: {
                    TITLE: 'Upload nieuw milestone resultaat',
                },
            },
            ASSIGN_SERVICE_PROVIDER: {
                CLIENT: {
                    TITLE: 'De aanvraag is afgewezen door de dienstverlener',
                },
                NOTARY: {
                    TITLE: 'De aanvraag is afgewezen door de dienstverlener',
                },
                SUPPORT: {
                    TITLE: 'Beoordeel de afwijzing door de dienstverlener',
                },
                BOOKKEEPER: {
                    TITLE: 'De aanvraag is afgewezen door de dienstverlener',
                },
            },
            INTAKE_INTERVIEW: {
                CLIENT: {
                    TITLE: 'Intake afspraak',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Intake afspraak',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Intake afspraak',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Intake afspraak',
                    DESCRIPTION: '',
                },
            },
            REVIEW_MILESTONE: {
                CLIENT: {
                    TITLE: 'Review milestone',
                },
                NOTARY: {
                    TITLE: 'Review milestone',
                },
                SUPPORT: {
                    TITLE: 'Review milestone',
                },
                BOOKKEEPER: {
                    TITLE: 'Review milestone',
                },
            },
            WAIT_FOR_PAYMENT_QUOTE: {
                CLIENT: {
                    TITLE: 'Betaling offerte',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Betaling offerte',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Betaling offerte',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Betaling offerte',
                    DESCRIPTION: '',
                },
            },
            VERIFY_ORGANIZATION: {
                CLIENT: {
                    TITLE: 'Verificatie voor aanvraag',
                    DESCRIPTION:
                        'Voor de digitale identificatie hebben we de volgende gegevens nodig per persoon. Vul hieronder de gegevens in van alle personen die geïdentificeerd moeten worden.',
                },
                NOTARY: {
                    TITLE: 'Verificatie voor aanvraag',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Verificatie voor aanvraag',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Verificatie voor aanvraag',
                    DESCRIPTION: '',
                },
            },
            UPLOAD_RESULT: {
                CLIENT: {
                    TITLE: 'Job afronding',
                    DESCRIPTION: '',
                },
                NOTARY: {
                    TITLE: 'Job afronding',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'Job afronding',
                    DESCRIPTION: '',
                },
                BOOKKEEPER: {
                    TITLE: 'Job afronding',
                    DESCRIPTION: '',
                },
            },
            EDIT_DETAILS: {
                CLIENT: {
                    TITLE: 'Jouw aanvraag is in behandeling',
                    DESCRIPTION:
                        '{tenant} bereidt de documenten voor. Wij houden je op de hoogte over de status van de opheffing. Als je actie moet ondernemen, wordt je hiervan per e-mail op de hoogte gesteld. Houd daarom jouw mailbox in de gaten.',
                },
                NOTARY: {
                    TITLE: 'Invullen gegevens',
                    DESCRIPTION: '',
                },
                SUPPORT: {
                    TITLE: 'De documenten voorbereiden',
                    DESCRIPTION:
                        'Een medewerker van {tenant} maakt de documenten gereed. Je wordt bij elke activiteit op de hoogte gesteld van de status van de opheffing. Als je actie dient te ondernemen, dan krijg je een notificatie hiervan per e-mail. Let dus goed op je mailbox.',
                },
                BOOKKEEPER: {
                    TITLE: 'Invullen gegevens',
                    DESCRIPTION: '',
                },
            },
            SIGN_BY_HAND: {
                CLIENT: {
                    TITLE: 'Verstuur documenten naar {tenant}',
                    DESCRIPTION: 'Print, onderteken en stuur de geleverde stukken per post op naar {tenant}.',
                },
                SUPPORT: {
                    TITLE: 'Wacht op ondertekende documenten',
                    DESCRIPTION: 'Print, onderteken en stuur de geleverde stukken per post op naar {tenant}.',
                },
                NOTARY: {
                    TITLE: 'Wacht op ondertekende documenten',
                    DESCRIPTION: 'Print, onderteken en stuur de geleverde stukken per post op naar {tenant}.',
                },
                BOOKKEEPER: {
                    TITLE: 'Verstuur documenten naar {tenant}',
                    DESCRIPTION: 'Print, onderteken en stuur de geleverde stukken per post op naar {tenant}.',
                },
            },
            APPROVE_DOCUMENT: {
                CLIENT: {
                    TITLE: 'Wacht op bevestiging door {tenant}',
                },
                SUPPORT: {
                    TITLE: 'Documenten versturen naar KvK',
                },
                NOTARY: {
                    TITLE: 'Documenten versturen naar KvK',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op bevestiging door {tenant}',
                },
            },
            DEREGISTER_COMPANY: {
                CLIENT: {
                    TITLE: 'Deregister company',
                    DESCRIPTION: 'Het bedrijf {company} wordt uitgeschreven.',
                },
                SUPPORT: {
                    TITLE: 'Controleer de KvK voor een update',
                    DESCRIPTION: 'Check de KvK voor een update en informeer cliënt zodra {company} is uitgeschreven.',
                },
                NOTARY: {
                    TITLE: 'Controleer de KvK voor een update',
                    DESCRIPTION: 'Check de KvK voor een update en informeer cliënt zodra {company} is uitgeschreven.',
                },
                BOOKKEEPER: {
                    TITLE: 'Deregister company',
                    DESCRIPTION: 'Het bedrijf {company} wordt uitgeschreven.',
                },
            },
            WAITING_PURCHASE_INSURANCE: {
                CLIENT: {
                    TITLE: 'Bereken je verzekeringspremie',
                    DESCRIPTION:
                        'Bereken in een paar stappen de maandelijkse premie van je zakelijke verzekering. Om de premie te berekenen beantwoord je eerst een paar vragen over je bedrijf.',
                },
                NOTARY: {
                    TITLE: 'Verzekering afsluiten',
                    DESCRIPTION: 'Wacht tot de klant klaar is met het afsluiten van de verzekering',
                },
                SUPPORT: {
                    TITLE: 'Verzekering afsluiten',
                    DESCRIPTION: 'Wacht tot de klant klaar is met het afsluiten van de verzekering',
                },
                BOOKKEEPER: {
                    TITLE: 'Bereken je verzekeringspremie',
                    DESCRIPTION:
                        'Bereken in een paar stappen de maandelijkse premie van je zakelijke verzekering. Om de premie te berekenen beantwoord je eerst een paar vragen over je bedrijf.',
                },
            },
            SUBMIT_DETAILS: {
                CLIENT: {
                    TITLE: 'Cliënt vult de gegevens in',
                },
                NOTARY: {
                    TITLE: 'Cliënt vult de gegevens in',
                },
                SUPPORT: {
                    TITLE: 'Cliënt vult de gegevens in',
                },
                BOOKKEEPER: {
                    TITLE: 'Cliënt vult de gegevens in',
                },
            },
            WAIT_FOR_PAYMENT: {
                CLIENT: { TITLE: 'Wacht op betaling' },
                NOTARY: { TITLE: 'Wacht op betaling' },
                SUPPORT: { TITLE: 'Wacht op betaling' },
                BOOKKEEPER: { TITLE: 'Wacht op betaling' },
            },
            WAIT_FOR_PAYMENT_INCORPORATION: {
                CLIENT: { TITLE: 'Wacht op betaling' },
                NOTARY: { TITLE: 'Wacht op betaling' },
                SUPPORT: { TITLE: 'Wacht op betaling' },
                BOOKKEEPER: { TITLE: 'Wacht op betaling' },
            },
            SUBMIT_ADDITIONAL_DETAILS: {
                CLIENT: { TITLE: 'Aanvullende gegevens indienen' },
                NOTARY: { TITLE: 'Aanvullende gegevens indienen' },
                SUPPORT: { TITLE: 'Aanvullende gegevens indienen' },
                BOOKKEEPER: { TITLE: 'Aanvullende gegevens indienen' },
            },
            SUBMIT_EXTRA_INFORMATION: {
                CLIENT: { TITLE: 'Aanvullende gegevens indienen' },
                NOTARY: { TITLE: 'Aanvullende gegevens indienen' },
                SUPPORT: { TITLE: 'Aanvullende gegevens indienen' },
                BOOKKEEPER: { TITLE: 'Aanvullende gegevens indienen' },
            },
            WAIT_FOR_IDENTIFICATION: {
                CLIENT: {
                    TITLE: 'Voltooi digitale identificatie',
                    DESCRIPTION:
                        'Voordat de notaris de oprichting kan starten dienen alle oprichter(s) zich digitaal te identificeren. Er is een uitnodiging per email naar elke oprichter gestuurd met een link om de digitale identificatie te starten. Is de mail niet goed aangekomen dan kun je het emailadres nog aanpassen. De uitnodiging wordt automatisch opnieuw verstuurd.',
                },
                NOTARY: {
                    TITLE: 'Wacht op digitale identificatie van de aandeelhouders',
                    DESCRIPTION:
                        'Elke persoon heeft een uitnodiging per e-mail ontvangen voor de digitale identificatie. Je kunt eenvoudig het e-mailadres of telefoonnummer van een aandeelhouder wijzigen zolang de identificatie nog niet is voltooid. De aanvrager kan dit ook zelf doen.',
                },
                SUPPORT: {
                    TITLE: 'Wacht op digitale identificatie van de aandeelhouders',
                    DESCRIPTION:
                        'Elke persoon heeft een uitnodiging per e-mail ontvangen voor de digitale identificatie. Je kunt eenvoudig het e-mailadres of telefoonnummer van een aandeelhouder wijzigen zolang de identificatie nog niet is voltooid. De aanvrager kan dit ook zelf doen.',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op digitale identificatie van de aandeelhouders',
                    DESCRIPTION:
                        'Elke persoon heeft een uitnodiging per e-mail ontvangen voor de digitale identificatie. Je kunt eenvoudig het e-mailadres of telefoonnummer van een aandeelhouder wijzigen zolang de identificatie nog niet is voltooid. De aanvrager kan dit ook zelf doen.',
                },
            },
            UPLOAD_TAXES: {
                DECLINE_DOCUMENT_DESCRIPTION:
                    'De fiscale cijfers zijn geüpload en staan onder - Documenten-. Download en bekijk de documenten. Zijn de stukken niet akkoord, klik op de knop om de documenten te weigeren. De klant dient vervolgens alle documenten opnieuw te uploaden. Geef ook feedback in de chat voor de klant.',
                CLIENT: {
                    TITLE: 'Upload fiscale documenten',
                },
                NOTARY: {
                    TITLE: 'Wachten op fiscale documenten',
                    DESCRIPTION:
                        'De online aanvraag is voltooid! De volgende stap is dat de fiscale stukken worden geupload. Op basis van de fiscale stukken kan de notaris de concept oprichtingsakte, concept inbrengakte en volmacht opstellen per BV. {tenant} controleert de documenten en neemt indien nodig, contact met de klant of de fiscaal adviseur op. Zodra alle documenten in orde zijn, neemt {tenant} contact op met de notaris om de procedure te starten.',
                },
                SUPPORT: {
                    TITLE: 'Wachten op fiscale documenten',
                    DESCRIPTION:
                        'De online aanvraag is voltooid! De volgende stap is dat de fiscale stukken worden geupload. Op basis van de fiscale stukken kan de notaris de concept oprichtingsakte, concept inbrengakte en volmacht opstellen per BV. {tenant} controleert de documenten en neemt indien nodig, contact met de klant of de fiscaal adviseur op. Zodra alle documenten in orde zijn, neemt {tenant} contact op met de notaris om de procedure te starten.',
                },
                BOOKKEEPER: {
                    TITLE: 'Upload fiscale documenten',
                    DESCRIPTION:
                        'Gefeliciteerd, de online aanvraag is voltooid! De volgende stap is dat de fiscale stukken worden geupload. Op basis van de fiscale stukken kan de notaris de concept oprichtingsakte, concept inbrengakte en volmacht opstellen per BV. {tenant} controleert de documenten en neemt indien nodig, contact met jou of jouw adviseur op.',
                },
            },
            UPLOAD_CONCEPT: {
                DISCUSS_OPTION_1: 'Bespreek concept akte fysiek op notariskantoor',
                DISCUSS_OPTION_2: 'Bespreek concept akte telefonish',
                CLIENT: {
                    TITLE: 'Wachten op review dossier',
                    DESCRIPTION: {
                        PART_1: 'Het dossier ligt nu bij de notaris. In de stap van review dossier doet de notaris het onderzoek en worden de conceptakte, volmacht en personal data card opgesteld. De aanvrager ontvangt per e-mail een notificatie om de conceptakte te bekijken en alle aandeelhouders krijgen per e-mail een notificatie om de volmacht digitaal te ondertekenen.',
                        PART_2: {
                            SUB_PART_1: 'Let op: ',
                            SUB_PART_2: 'alle dossiers worden door de notarissen zo snel mogelijk opgepakt. Het kan voorkomen dat je dossier tot op ',
                            SUB_PART_3: 'de één na laatste dag ',
                            SUB_PART_4:
                                'op deze stap blijft staan. Wees gerust, de notaris is bezig met je dossier en upload uiterlijk deze dag de documenten ter goedkeuring en ondertekening. Nadat de notaris met iedere aandeelhouder de akte heeft besproken (belehrung), wordt de BV ingeschreven bij de Kamer van Koophandel.',
                        },
                        PART_3: 'Uitzondering: Het oprichten van een BV kan vertraging oplopen als er wijzigingen in het dossier nodig zijn, aanvullende informatie wordt opgevraagd, en/of acties van de oprichter(s) uitblijven. Zorg voor een zorgvuldige aanlevering van alle vereiste documenten en reageer snel op verzoeken om het proces soepel te laten verlopen.',
                    },
                },
                NOTARY: {
                    TITLE: 'Review dossier',
                    CLASSIFY_DOCUMENTS: 'Classificeer de documenten',
                    VALIDATION_ALL: 'Selecteer ten minste één document van type Volmacht en Concept Akte.',
                    VALIDATION_ALL_TRANSFER: 'Selecteer ten minste één document van type Volmacht, Concept Akte en Inbreng Concept',
                    VALIDATION_RE_UPLOAD: 'Selecteer ten minste één documenttype Volmacht.',
                    VALIDATION_RE_UPLOAD_TRANSFER: 'Selecteer ten minste één documenttype Volmacht en Inbreng.',
                    RE_UPLOAD_TITLE: 'Het lijkt erop dat u de POA- en PDC-documenten opnieuw moet uploaden.',
                },
                SUPPORT: { TITLE: 'Review dossier' },
                BOOKKEEPER: { TITLE: 'Review dossier' },
            },
            UPLOAD_LIQUIDATION: {
                SUPPORT: {
                    VALIDATION_ALL: 'Selecteer ten minste één document van type: Liquidatie Resolutie en Liquidatie Kvk.',
                },
            },
            DOSSIER_QUEUED: {
                CLIENT: {
                    TITLE: 'Dossier is aangemeld bij de notaris',
                    DESCRIPTION: {
                        PARAGRAPH_1:
                            'Het dossier is aangemeld bij de notaris. Je dossier komt in de wachtrij bij de notaris. De notaris behandelt de dossiers in de volgorde van binnenkomst. Dit kan betekenen dat er een korte wachtperiode is voordat jouw dossier aan de beurt is. In het geval van een versnelde procedure of een spoedaanvraag wordt je dossier met voorrang opgepakt.',
                        PARAGRAPH_2:
                            'Je ontvangt een notificatie per e-mail zodra de notaris het dossier in behandeling neemt. Rechtsboven in het dossier zie je de verwachte oprichtingsdatum. Let erop dat dat de doorlooptijd in werkdagen is en het rekening houdt met feestdagen en weekenden in Nederland.',
                        PARAGRAPH_3: {
                            PART_1: 'Let op',
                            PART_2: 'alle dossiers worden door de notarissen zo snel mogelijk opgepakt. Het kan voorkomen dat je dossier tot op',
                            PART_3: 'de één na laatste dag',
                            PART_4: 'op deze stap blijft staan. Wees gerust, de notaris kan de oprichting binnen 1 werkdag voltooien en indienen bij de KvK.',
                        },
                        PARAGRAPH_4: {
                            PART_1: 'Uitzondering:',
                            PART_2: 'Het oprichten van een BV kan vertraging oplopen als er wijzigingen in het dossier nodig zijn, aanvullende informatie wordt opgevraagd, en/of acties van de oprichter(s) uitblijven. Zorg voor een zorgvuldige aanlevering van alle vereiste documenten en reageer snel op verzoeken om het proces soepel te laten verlopen.',
                        },
                    },
                },
                NOTARY: {
                    TITLE: 'Dossier is aangemeld bij de notaris',
                    DESCRIPTION: {
                        PARAGRAPH_1:
                            'De online aanvraag is afgerond, de digitale identificatie is voltooid en eventuele aanvullende documenten zijn geüpload. Het dossier is nu bij jullie aangemeld. Download het dossier en druk daarna op de knop zodat je het dossier in behandeling neemt. De cliënt ontvangt een notificatie per e-mail dat het dossier in behandeling is genomen.',
                        PARAGRAPH_2: {
                            PART_1: 'Let op:',
                            PART_2: 'zolang het dossier niet in behandeling is genomen, kan de cliënt nog wijzigingen aanbrengen, het dossier verplaatst worden en wordt er geen bedrag aan de notaris gekoppeld bij een annulering.',
                        },
                    },
                    DOSSIER_SUBMITTED: 'Dossier in behandeling',
                    DOSSIER_SUBMITTED_OFFICE_VISIT: 'Dossier in behandeling – klant op locatie',
                    OFFICE_VISIT_FAILED: 'Het dossier is in behandeling, maar het verzoek om kantoorbezoek is mislukt. Vraag het opnieuw aan vanuit de volgende stap.',
                },
                SUPPORT: {
                    TITLE: 'Dossier is aangemeld bij de notaris',
                },
                BOOKKEEPER: {
                    TITLE: 'Dossier is aangemeld bij de notaris',
                },
            },
            REVIEW_DOSSIER: {
                BOOKKEEPER: {
                    TITLE: 'Review UBO aanvraag',
                    DESCRIPTION:
                        'De notaris heeft de aanvraag ontvangen, controleert de aanvraag en gaat verder met de procedure. U ontvangt per e-mail een notificiatie zodra de aanvraag is ingediend bij het UBO-register.',
                },
                CLIENT: {
                    TITLE: 'Review UBO aanvraag',
                    DESCRIPTION:
                        'De notaris heeft de aanvraag ontvangen, controleert de aanvraag en gaat verder met de procedure. U ontvangt per e-mail een notificiatie zodra de aanvraag is ingediend bij het UBO-register.',
                },
                NOTARY: {
                    TITLE: 'Review UBO aanvraag',
                },
                SUPPORT: {
                    TITLE: 'Review UBO aanvraag',
                },
            },
            FINISH_REGISTRATION: {
                BOOKKEEPER: {
                    TITLE: 'Bevestig UBO registratie',
                    DESCRIPTION:
                        'De aanvraag voor UBO registratie is ingediend bij het UBO register. U ontvangt een bericht per e-mail zodra de registratie is bevestigd.',
                },
                CLIENT: {
                    TITLE: 'Bevestig UBO registratie',
                    DESCRIPTION:
                        'De aanvraag voor UBO registratie is ingediend bij het UBO register. U ontvangt een bericht per e-mail zodra de registratie is bevestigd.',
                },
                NOTARY: {
                    TITLE: 'Bevestig UBO registratie',
                },
                SUPPORT: {
                    TITLE: 'Bevestig UBO registratie',
                },
            },
            WAIT_FOR_PROCESSES: {
                BOOKKEEPER: {
                    TITLE: 'Wacht op voltooien UBO registratie(s)',
                    DESCRIPTION:
                        "Dank voor het voltooien van de aanvraag. De notaris zal de aanvraag in behandeling nemen. Indien u voor meerdere BV's de aanvraag heeft verricht, ziet u in het overzicht de aanvraagprocedure per BV.",
                },
                CLIENT: {
                    TITLE: 'Wacht op voltooien UBO registratie(s)',
                    DESCRIPTION:
                        "Dank voor het voltooien van de aanvraag. De notaris zal de aanvraag in behandeling nemen. Indien u voor meerdere BV's de aanvraag heeft verricht, ziet u in het overzicht de aanvraagprocedure per BV.",
                },
                NOTARY: {
                    TITLE: 'Wacht op voltooien UBO registratie(s)',
                    DESCRIPTION:
                        "Dank voor het voltooien van de aanvraag. De notaris zal de aanvraag in behandeling nemen. Indien u voor meerdere BV's de aanvraag heeft verricht, ziet u in het overzicht de aanvraagprocedure per BV.",
                },
                SUPPORT: {
                    TITLE: 'Wacht op voltooien UBO registratie(s)',
                    DESCRIPTION:
                        "Dank voor het voltooien van de aanvraag. De notaris zal de aanvraag in behandeling nemen. Indien u voor meerdere BV's de aanvraag heeft verricht, ziet u in het overzicht de aanvraagprocedure per BV.",
                },
            },
            WAIT_FOR_PREPARE_SIGNING: {
                CLICK_TO_PREPARE: 'Bereid het document voor',
                CLIENT: {
                    TITLE: 'Wacht op voorbereiden ondertekening',
                    DESCRIPTION:
                        'De notaris is de documenten aan het voorbereiden voor ondertekening. Je ontvangt per e-mail een notificatie zodra deze documenten klaar staan in jouw dashboard.',
                },
                NOTARY: {
                    TITLE: 'Wacht op voorbereiden ondertekening',
                    DESCRIPTION:
                        'Wacht op ondertekening door de aandeelhouders. Verkeerde document geupload? Verwijder eenvoudig het document aan en upload de correcte versie.',
                },
                SUPPORT: {
                    TITLE: 'Wacht op voorbereiden ondertekening',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op voorbereiden ondertekening',
                },
            },
            APPROVE_CONCEPT: {
                CLIENT: {
                    TITLE: 'Goedkeuring conceptakte',
                    DESCRIPTION:
                        'De conceptakte is opgesteld door de notaris en staat klaar voor jouw goedkeuring. Neem de akte rustig door. Let vooral op eerste twee pagina’s (naam en doel) en de laatste pagina (slotverklaring). Is alles correct? Accordeer de conceptakte om door te gaan naar de volgende stap. Indien er iets incorrect is, stuur de notaris een bericht. Zie - Berichten - hieronder.',
                },
                NOTARY: {
                    TITLE: 'Wachten op goedkeuring conceptakte',
                    DESCRIPTION:
                        'De aanvrager heeft de conceptakte ontvangen, neemt deze door en zal de akte vervolgens goedkeuren. Tevens is er een toelichting op de conceptakte meegestuurd ter extra informatie. Als de aanvrager de conceptakte al heeft goedgekeurd tijdens de bespreking, kun je zelf de akte goedkeuren.',
                },
                SUPPORT: {
                    TITLE: 'Wachten op goedkeuring conceptakte',
                },
                BOOKKEEPER: {
                    TITLE: 'Wachten op goedkeuring conceptakte',
                },
            },
            WAIT_FOR_SIGNING: {
                CLIENT: {
                    TITLE: 'Ondertekening volmacht',
                    DESCRIPTION:
                        'De volmacht is opgesteld door de notaris en staat klaar voor ondertekening. Er is een uitnodiging per email naar elke oprichter gestuurd om de volmacht digitaal te ondertekenen.',
                },
                NOTARY: {
                    TITLE: 'Wacht op ondertekening door de aandeelhouders',
                },
                SUPPORT: {
                    TITLE: 'Wacht op ondertekening door de aandeelhouders',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op ondertekening door de aandeelhouders',
                },
            },
            CONFIRM_DISCUSSION: {
                ACTION: 'Confirm discussion',
                CLIENT: {
                    TITLE: 'Wacht op bespreking conceptakte',
                    DESCRIPTION:
                        'De notaris bespreekt de akte van oprichting met alle oprichters. Dit gebeurt digitaal, telefonisch of op kantoor bij de notaris. De notaris beslist op welke wijze dit gebeurd. Maak een afspraak met de notaris voor de bespreking van de akte. Hier vind je de contactgegevens.',
                },
                NOTARY: {
                    TITLE: 'Bespreking conceptakte',
                    DESCRIPTION:
                        'De conceptakte is goedgekeurd. Bespreek de conceptakte met de oprichters. Cliënt zal contact opnemen met jouw notariskantoor om een afspraak in te plannen voor de bespreking van de akte. Als de akte al is besproken, kun je doorklikken om door te gaan naar de volgende stap.',
                },
                SUPPORT: {
                    TITLE: 'Bespreking conceptakte',
                    DESCRIPTION:
                        'De conceptakte is goedgekeurd. Bespreek de conceptakte met de oprichters. Cliënt zal contact opnemen met jouw notariskantoor om een afspraak in te plannen voor de bespreking van de akte. Als de akte al is besproken, kun je doorklikken om door te gaan naar de volgende stap.',
                },
                BOOKKEEPER: {
                    TITLE: 'Bespreking conceptakte',
                    DESCRIPTION:
                        'De conceptakte is goedgekeurd. Bespreek de conceptakte met de oprichters. Cliënt zal contact opnemen met jouw notariskantoor om een afspraak in te plannen voor de bespreking van de akte. Als de akte al is besproken, kun je doorklikken om door te gaan naar de volgende stap.',
                },
            },
            FINALIZE_DEED: {
                PASS_DATE: 'Passeerdatum',
                USE_ACTUAL_PASS_DATE: 'Passeer datum uit het verleden gebruiken als uitbetaaldatum',
                VALIDATION: 'Selecteer ten minste één document van het type Akte.',
                RE_UPLOAD: 'Upload nieuwe finale akte',
                CLIENT: {
                    TITLE: 'Voltooi de akte',
                    DESCRIPTION:
                        'De notaris zal de oprichtingsakte passeren en uploaden in jouw dashboard. Na het passeren is de BV formeel opgericht. De notaris zal vervolgens de BV inschrijven bij het Handelsregister van de Kamer van Koophandel en het UBO register.',
                },
                NOTARY: {
                    TITLE: 'Voltooi de akte',
                    DESCRIPTION:
                        'De conceptakte is besproken en de akte kan worden gepasseerd. Upload de gepasseerde akte in het portaal om aan te geven aan de cliënt dat de BV formeel is opgericht en dat de inschrijving bij de Kamer van Koophandel ligt. De cliënt krijgt hiervoor een notificatie.',
                },
                SUPPORT: {
                    TITLE: 'Voltooi de akte',
                    DESCRIPTION:
                        'De conceptakte is besproken en de akte kan worden gepasseerd. Upload de gepasseerde akte in het portaal om aan te geven aan de cliënt dat de BV formeel is opgericht en dat de inschrijving bij de Kamer van Koophandel ligt. De cliënt krijgt hiervoor een notificatie.',
                },
                BOOKKEEPER: {
                    TITLE: 'Voltooi de akte',
                    DESCRIPTION:
                        'De conceptakte is besproken en de akte kan worden gepasseerd. Upload de gepasseerde akte in het portaal om aan te geven aan de cliënt dat de BV formeel is opgericht en dat de inschrijving bij de Kamer van Koophandel ligt. De cliënt krijgt hiervoor een notificatie.',
                },
            },
            REGISTER_KVK: {
                RSIN_NUMBER: 'RSIN nummer',
                VALIDATION: 'Selecteer ten minste één document van het type Kvk en één aandeelhoudersregister.',
                SELECT_REGISTERED_COMPANY: 'Selecteer de entiteit uit het KVK register:',
                SBI_CODES: 'Vul de SBI code(s) in van de onderneming. Klik op enter om de volgende in te vullen.',
                MAIN_ACTIVITY: 'Wat is de hoofdactiviteit van de BV?',
                MAIN_ACTIVITY_PREFIX: 'Het voeren van een onderneming op het gebied van {activity}',
                CLIENT: {
                    TITLE: 'Wachten op registratie door Kamer van Koophandel',
                    DESCRIPTION:
                        'De notaris dient de BV in bij het Handelsregister van de Kamer van Koophandel en het UBO register. Nadat de BV is ingeschreven door de Kamer van Koophandel ontvang je het uittreksel en het KvK nummer in je dashboard. De KvK zal automatisch de inschrijving doorsturen naar de Belastingdienst. Na ongeveer 1-2 weken ontvang je van de Belastingdienst een brief op het vestigingsadres. Indien van toepassing staat in de brief het BTW nummer.',
                    DESCRIPTION_FOUNDATION:
                        'De notaris schrijft de stichting in bij het Handelsregister van de Kamer van Koophandel en het UBO-register. Na de inschrijving door de KvK ontvang je het uittreksel en het KvK-nummer in uw dashboard.',
                },
                NOTARY: {
                    TITLE: 'Voltooi procedure',
                },
                SUPPORT: {
                    TITLE: 'Voltooi procedure',
                },
                BOOKKEEPER: {
                    TITLE: 'Voltooi procedure',
                },
            },
            COLLECT_FEEDBACK: {
                CLIENT: {
                    TITLE: 'Verzamel feedback',
                },
                NOTARY: {
                    TITLE: 'Verzamel feedback',
                    DESCRIPTION: 'Klant zal feedback geven.',
                },
                SUPPORT: {
                    TITLE: 'Verzamel feedback',
                    DESCRIPTION: 'Klant zal feedback geven.',
                },
                BOOKKEEPER: {
                    TITLE: 'Verzamel feedback',
                    DESCRIPTION: 'Klant zal feedback geven.',
                },
            },
            WAIT_FOR_UPSELL: {
                CLIENT: {
                    TITLE: 'Wacht op registratie holding procedure',
                    DESCRIPTION:
                        'De procedures van de bijbehorende holding(s) moet eerst worden geregistreerd voordat de notaris de procedure van deze BV kan afronden. Even geduld aub.',
                },
                NOTARY: {
                    TITLE: 'Wacht op registratie holding procedure',
                    DESCRIPTION:
                        'De procedures van de bijbehorende holding(s) moet eerst worden geregistreerd voordat je de procedure van deze BV kunt afronden.',
                },
                SUPPORT: {
                    TITLE: 'Wacht op registratie holding procedure',
                    DESCRIPTION:
                        'De procedures van de bijbehorende holding(s) moet eerst worden geregistreerd voordat je de procedure van deze BV kunt afronden.',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op registratie holding procedure',
                    DESCRIPTION:
                        'De procedures van de bijbehorende holding(s) moet eerst worden geregistreerd voordat je de procedure van deze BV kunt afronden.',
                },
            },
            // Titles only: the card header and the stepper build this key dynamically from the state, so
            // they have to resolve globally. The descriptions live in IncorporationWaitForParentProcess.vue.
            WAIT_FOR_PARENT_PROCESS: {
                CLIENT: { TITLE: 'In afwachting van de oprichting' },
                NOTARY: { TITLE: 'In afwachting van de oprichting' },
                SUPPORT: { TITLE: 'In afwachting van de oprichting' },
                BOOKKEEPER: { TITLE: 'In afwachting van de oprichting' },
            },
            NOTARY_CHECK: {
                CLIENT: {
                    TITLE: 'Notaris controle',
                    DESCRIPTION: 'De notaris controleert alle gegevens voordat deze in het organisatieoverzicht worden verwerkt.',
                },
                NOTARY: {
                    TITLE: 'Notaris controle',
                    DESCRIPTION: 'Controleer a.u.b. of alle gegevens correct zijn, zodat de juiste gegevens in het organisatieoverzicht worden verwerkt.',
                },
                SUPPORT: {
                    TITLE: 'Notaris controle',
                    DESCRIPTION: 'Controleer a.u.b. of alle gegevens correct zijn, zodat de juiste gegevens in het organisatieoverzicht worden verwerkt.',
                },
                BOOKKEEPER: {
                    TITLE: 'Notaris controle',
                    DESCRIPTION: 'Controleer a.u.b. of alle gegevens correct zijn, zodat de juiste gegevens in het organisatieoverzicht worden verwerkt.',
                },
            },
            SUCCESSFUL: {
                DIGITAL_SHR: 'om het organisatieoverzicht te openen.',
                CLIENT: {
                    TITLE: 'Procedure voltooid',
                },
                NOTARY: {
                    TITLE: 'Procedure voltooid',
                    DESCRIPTION: 'De procedure is voltooid. Hartelijk bedankt voor de uitstekende service!',
                },
                SUPPORT: {
                    TITLE: 'Procedure voltooid',
                    DESCRIPTION: 'De procedure is voltooid. Hartelijk bedankt voor de uitstekende service!',
                },
                BOOKKEEPER: {
                    TITLE: 'Procedure voltooid',
                    DESCRIPTION: 'De procedure is voltooid. Hartelijk bedankt voor de uitstekende service!',
                },
            },
            CANCELLED: {
                CLIENT: {
                    TITLE: 'De aanvraag is geannuleerd',
                },
                NOTARY: {
                    TITLE: 'De aanvraag is geannuleerd',
                },
                SUPPORT: {
                    TITLE: 'De aanvraag is geannuleerd',
                },
                BOOKKEEPER: {
                    TITLE: 'De aanvraag is geannuleerd',
                },
            },
            WAIT_FOR_PAYMENT_EXTRA: {
                SUPPORT: {
                    TITLE: 'Wachten op extra betaling',
                },
                CLIENT: {
                    TITLE: 'Wachten op extra betaling',
                },
                NOTARY: {
                    TITLE: 'Wachten op extra betaling',
                },
            },
            REQUEST_DOCUMENTS: {
                SUPPORT: {
                    TITLE: 'Wachten op indiening van vereiste documenten',
                    DESCRIPTION: 'De cliënt heeft een email ontvangen om de aangevraagde documenten te uploaden. De volgende document zijn opgevraagd:',
                },
                CLIENT: {
                    TITLE: 'Dien gevraagde documenten in',
                },
                NOTARY: {
                    TITLE: 'Wachten op indiening van vereiste documenten',
                    DESCRIPTION: 'De cliënt heeft een email ontvangen om de aangevraagde documenten te uploaden. De volgende document zijn opgevraagd:',
                },
                BOOKKEEPER: {
                    TITLE: 'Dien gevraagde documenten in',
                },
            },
            REQUEST_CLIENT_INFORMATION: {
                SUPPORT: {
                    TITLE: 'Wachten op contact met de cliënt',
                },
                CLIENT: {
                    TITLE: 'De notaris wil u graag spreken',
                },
                NOTARY: {
                    TITLE: 'Wachten op contact met de cliënt',
                },
                BOOKKEEPER: {
                    TITLE: 'De notaris wil de cliënt graag spreken',
                },
            },
            WAIT_FOR_FORM: {
                SUPPORT: {
                    TITLE: 'Wacht op formulier',
                },
                CLIENT: {
                    TITLE: 'Wacht op formulier',
                },
                NOTARY: {
                    TITLE: 'Wacht op formulier',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op formulier',
                },
            },
            POST_SALE_UPSELL: {
                SUPPORT: {
                    TITLE: 'Open een gratis zakelijke bankrekening',
                    DESCRIPTION: 'Wacht tot de klant het GoDutch-proces heeft voltooid.',
                },
                CLIENT: {
                    TITLE: 'Open een gratis zakelijke bankrekening',
                },
                NOTARY: {
                    TITLE: 'Open een gratis zakelijke bankrekening',
                },
                BOOKKEEPER: {
                    TITLE: 'Open een gratis zakelijke bankrekening',
                },
            },
            SUBMIT_OFFER: {
                SUPPORT: {
                    TITLE: 'Upload een offerte',
                },
                CLIENT: {
                    TITLE: 'De boekhouder maakt een offerte',
                },
                NOTARY: {
                    TITLE: 'Upload een offerte',
                },
            },
            REVIEW_OFFER: {
                SUPPORT: {
                    TITLE: 'De klant bekijkt de offerte',
                },
                CLIENT: {
                    TITLE: 'Bekijk de offerte van de boekhouder',
                },
                NOTARY: {
                    TITLE: 'De klant bekijkt de offerte',
                },
            },
            WAIT_FOR_PAYMENT_PRODUCT: {
                SUPPORT: {
                    TITLE: 'Wacht op betaling',
                },
                CLIENT: {
                    TITLE: 'Wacht op betaling',
                },
                NOTARY: {
                    TITLE: 'Wacht op betaling',
                },
            },
            SUBMIT_PRODUCT_INFO: {
                SUPPORT: {
                    TITLE: 'Aanvullende informatie indienen',
                },
                CLIENT: {
                    TITLE: 'Aanvullende informatie indienen',
                },
                NOTARY: {
                    TITLE: 'Aanvullende informatie indienen',
                },
            },
            SUB_PROCESSES: 'Subprocessen',
            PARENT_PROCESS: 'Bovenliggende proces',
            CURRENT_STATUS_TITLE: 'Huidige status oprichting',
            STEP_TITLE: 'Stap',
            INCORPORATION_LIVE: 'Gefeliciteerd, jouw BV staat live!',
            GO_TO_DASHBOARD: 'Bekijk je oprichtingen',
            RELATED_PROCESS: 'Gerelateerd proces:',
            CURRENT_STEP: 'Huidige stap',
            CHANGE_ORGANIZATION_NAME: 'Organisatie naam aanpassen',
            SEND_A_REMINDER: 'Verstuur herinnering',
            SKIP: 'Overslaan',
            RESET: 'Reset',
            REMOVE: 'Verwijder',
            APPROVE_THE_CONCEPT: 'Keur het concept goed',
            CHANGE_THE_CONCEPT: 'Vraag wijzigingen aan',
            REJECT_THE_CONCEPT: 'Verwerp concept',
            REASON_REJECT_THE_CONCEPT: 'Geef de notaris aan welke wijzigen er gemaakt moeten worden',
            UPLOAD_NEW_CONCEPT_VERSION: 'Upload een nieuwe conceptversie',
            MESSAGE_DESCRIPTION:
                'Als de notaris informatie nodig heeft, neemt hij of zij contact met je op en stuurt je een bericht. Je ontvangt een melding per e-mail. Het is niet nodig om de notaris een bericht te sturen over de status van de procedure. Hiervoor zijn automatische meldingen ingeschakeld.',
            MESSAGE_DESCRIPTION_NOTARY:
                'Als je als notaris informatie nodig hebt over de procedure dan kun je deze rechtstreeks opvragen bij de klant. De klant (en {tenant}) ontvangt een melding van het bericht en zal contact opnemen via dit bericht scherm. De klant zal niet ongevraagd contact opnemen over de loop van de procedure. Hiervoor zijn automatische berichten namelijk ingesteld.',
            POA: 'Volmacht',
            PDC: 'PDC',
            CONCEPT: 'Concept Akte',
            TRANSLATION: 'Vertaling',
            COVER_LETTER: 'Brief',
            LIQUIDATION_RESOLUTION: 'Liquidatie Resolutie',
            LIQUIDATION_KVK: 'Liquidatie Kvk',
            OTHER: 'Iets anders',
            DEED: 'Akte',
            TRANSFER_DEED: 'Inbreng deed',
            TRANSFER_CONCEPT: 'Inbreng concept',
            PLEASE_FILL_IN: 'Vul de gegevens in',
            IS_FULLY_PAID: 'Is volledig betaald',
            KVK: 'KvK uittreksel',
            SHR: 'Aandeelhoudersregister',
            RESET_IDENTIFICATION: 'Identificatie resetten',
            RESET_EXPLANATION:
                'Klik op de - Reset - knop om de uitnodiging van de digitale identificatie opnieuw te sturen. Je kunt hiervan gebruik maken indien de oprichter zichzelf niet correct heeft geïdentificeerd. Selecteer de gewenste persoon en klik op de kop “reset”',
            SKIP_EXPLANATION:
                'Skip - knop om de stap van de digitale identificatie over te slaan. Je kunt hiervan gebruik maken indien er problemen zijn met de digitale identificatie en de oprichters rechtstreeks door de notaris worden geïdentificeerd.',
            SKIP_SIGNING_EXPLANATION: 'Als de aandeelhouders de volmacht op kantoor komen tekenen, dan kan de digitale ondertekening worden overgeslagen.',
            CONVERT_HOLDING: 'Zet aandeelhouder om naar holding',
            CONVERT_HOLDING_EXPLANATION: 'Dit zal een holding sub process starten. Let op: De cliënt dient vooraf te betalen voor deze holding',
            CONVERT_HOLDING_CONFIRM: 'Aandeelhouder omzetten naar holding',
            RE_UPLOAD_DOCUMENT: 'Her-upload documenten',
            UBO: 'Ubo',
            PEP: 'Pep',
        },
        COLLECT_FEEDBACK: {
            QUESTION_1: {
                TITLE: 'Waarom heb je voor {tenant} gekozen?',
                TOOLTIP: 'Meerdere antwoorden mogelij',
                COMPETITIVE_PRICE: 'Scherpe prijs',
                DIGITAL_PROCESS: 'Volledig digitaal proces',
                REFERRED: 'Verwezen door iemand anders',
                TRANSPARENT_PROCESS: 'Transparant proces',
                FAST_TURNAROUND_TIME: 'Snelle doorlooptijd',
                OTHER: 'Anders, namelijk',
            },
            QUESTION_2: 'Waar ben je het minst tevreden over?',
            QUESTION_3: 'Als je direct iets zou kunnen verbeteren, wat zou je aanpassen?',
            QUESTION_4: 'Waar zouden we je nog meer bij kunnen helpen om het ondernemen makkelijker te maken?',
            QUESTION_5: {
                TITLE: 'Welk cijfer zou je de notaris geven?',
                TOOLTIP: '10 is geweldig en 1 is slecht',
            },
            QUESTION_6: 'Waarom geef je dit cijfer?',
            QUESTION_7: {
                TITLE: 'Welk cijfer zou je het {tenant} geven?',
                TOOLTIP: '10 is geweldig en 1 is slecht',
            },
            WAIT_FEEDBACK_REVIEW: 'Wacht tot we uw feedback hebben verwerkt.',
            CLIENT: {
                REVIEW_SERVICE_PROVIDER: 'Voltooi de procedure door de serviceprovider te beoordelen.',
                RATE_SERVICE_PROVIDER: 'Hoe zou u de dienstverlener beoordelen?',
                REVIEW_NOTARY: 'Voltooi de procedure door de notaris te beoordelen.',
                RATE_NOTARY: 'Hoe zou u de notaris beoordelen?',
                COMMENT_SERVICE_PROVIDER: 'Wilt u nog een toelichting geven?',
            },
            SERVICE_PROVIDER: {
                REVIEW_SERVICE_PROVIDER: 'Voltooi de procedure door uw cliënt te beoordelen. Hierna wordt de uitbetaling voldaan.',
                RATE_SERVICE_PROVIDER: 'Hoe zou u uw cliënt beoordelen?',
                COMMENT_SERVICE_PROVIDER: 'Wilt u nog een toelichting geven?',
            },
        },
    },
};
